import { LANG_LOAD, LANG_CONFIG } from './actionType';

/**
 * @typedef {Object} LanguageState
 * @property {boolean}  isInit
 * @property {string[]} avail - The available language value.
 * @property {string} default - The default language value.
 * @property {string} current - The current language value.
 * @property {Object} dict - Custom object for mapping translations key with excel.
 */

export const LanguageState = {};

export const initialState = {
    isInit: false,
    avail: ['en'],
    default: 'en',
    current: 'en',
    dict: {
        Lang: 'English',
        PatientInfo: {
            log: {
                DELETE_RETAINER: 'Remove Request',
                REFINEMENT_X_SUBMITTED: {
                    REFINEMENT: 'REFINEMENT',
                    SUBMITTED: 'SUBMITTED',
                    admin: 'by TrioClear Team',
                    doctor: 'by Doctor',
                },
                REFINEMENT_X_: {
                    REFINEMENT: 'SUBMITTED',
                },
                DEFECT_RESPONDED: 'defective impression: {{status_remarks}} is selected',
                DEFECT_RESPONDED_RETAKE: 'defective impression alert. Please upload a new Impression in the chatbox.',
                DEFECT_UPLOADED:
                    '{{status_param2}} Defect on Impression or Scan. Please open Design Simulation for further actions',
                viewDefectPhotos: 'View Defect Photos',
                RETAINER_SET_DELIVERED:
                    'Retainer {{status_param1}} - {{status_param2}} dispatched to our distributor {{status_remarks}}',
                RETAINER_SET_DELIVERED_V2: 'Retainer dispatched to our distributor',
                RETAINER_ALL_DELIVERED: 'All {{status_remarks}} sets delivered',
                DRAFT: 'Draft created',
                SUBMITTED: 'Prescription Submitted by Doctor',
                SELF_DESIGN_SUBMITTED: 'Patient Information Submitted by Doctor',
                AWAITING: 'Awaiting More Record',
                RECEIVED:
                    'All materials have been confirmed and the treatment plan is expected to be delivered on {{status_param1}} {{status_param2}}',
                TREATMENNT_PLAN_UPLOADED: 'Treatment Plan {{plan_no}} Uploaded',
                TREATMENNT_PLAN_CHANGED_REQUEST_RECEIVED: 'Treatment Plan {{plan_no}} Change Request Received',
                TREATMENNT_PLAN_APPROVED: 'Treatment Plan {{plan_no}} Approved',
                SELF_DESIGN_ALIGNER: 'Aligner',
                SELF_DESIGN_ATTACHMENT_TEMPLATES: 'Attachment Templates',
                SELF_DESIGN_PASSIVE_ALIGNER: 'Passive Aligner',
                SELF_DESIGN_RETAINER: 'Retainer',
                SELF_DESIGN_TRIMLINE: 'Trimline',
                SELF_DESIGN_ALIGNER_BATCH_DELIVERED: 'Aligner Batch {{batch_no}} Delivered',
                SELF_DESIGN_TRIMLINE_GINGIVAL_COVER: 'Gingival Cover',
                SELF_DESIGN_TRIMLINE_SCALLOP_CUTTING: 'Scallop Cutting',
                PRODUCTION: 'Production in Progress',
                ALIGNER_SET_DELIVERED: 'Aligner Set {{status_param1}}-{{status_param2}} dispatched to our distributor',
                NEXT_SET_REQUEST: 'Request for Next Aligner Set',
                ALL_DELIVERED: 'All Aligner Sets Delivered',
                ENDED: 'Case ended due to expiry. Please create a new case if retainer or refinement is needed',
                REFINEMENTS: 'Refinement Prescription Received',
                RETAINER_REQUESTED: 'Doctor Requested Retainer',
                REFINEMENT: 'Uploaded Refinement',
                RETAINER: 'Retainer',
                ALIGNERS_REQUESTED: 'Doctor Requested Aligners',
                UPLOADED_RADIOGRAPHS: 'Uploaded Radiographs',
                UPLOADED_PHOTOGRAPHS: 'Uploaded Photos',
                UPLOADED_IMPRESSION: 'Uploaded Impression',
                UPLOADED_TREATMENT_PLAN: 'Uploaded Treatment Plan',
                UPLOADED_INDIVIDUAL_STL_FILES: 'Uploaded Individual STL Files',
                ALIGNERS_STEP_DELIVERED: 'Aligners {{step}} Delivered',
                ALIGNERS_STEP_PRODUCTION_IN_PROGRESS: 'Aligners {{step}} Production in Progress',
                RETAINER_DELIVERED: 'Retainer {{retainer_no}} Delivered',
                STEP: 'Step',
                UPLOADED_MISSING_PHOTOS_RADIOS: 'Upload Missing Photos / Radiographs',
                UPLOADED_MISSING_IMPRESSIONS: 'Upload Missing Impressions',
                UNKNOWN: 'Unknown',
                VIEW_RADIOGRAPHS: 'View Radiographs',
                VIEW_PHOTOS: 'View Photos',
                VIEW_IMPRESSION: 'View Impression',
                VIEW_IMPRESSIONS: 'View Impressions',
                VIEW_REFINEMENT: 'View Refinement',
                VIEW_RETAINER_REQUEST: 'View Retainer Request',
                MARK_DELIVERED: 'Mark Delivered',
                MARK_PRODUCTION_IN_PROGRESS: 'Mark as Production In Progress',
                VIEW_TREATMENT_PLAN: 'View Treatment Plans',
                VIEW_QUESTIONNAIRE: 'View Prescription Notes',
                VIEW_FINISHING_RETAINER: 'View Finishing Retainer Prescription',
                PRODUCTION_IN_PROGRESS: 'Production In Progress',
                CLINICAL_SIMULATION: 'Trio iDesign™ and Chatbox',
                VIEW_STL_FILES: 'View STL Files',
                LAST_APPROVAL_UNDONE: 'Treatment Plan {{plan_no}} has been undone',
                TREATMENNT_PLAN_UPDATED: 'Treatment Plan {{plan_no}} Updated',
                RECEIVED_STATUS_UPDATE:
                    'Delivery date of treatment plan has been updated to {{status_param1}} {{status_param2}} due to typo from technicians',
                DEFECT_RESPONDED1:
                    "Defective Impression image {{status_param1==0?'Rescan':status_param1==1?'Send Cycle 1 Only:'Send Cycle 1 to 6'}} request",
                VIEW_DEFECT_RESUBMIT: 'View Defect: Resubmit Case',
                DEFECT_RESUBMIT: 'Defect: Resubmit Case',
                ATTENTION_NEEDED: '(Attention Needed *)',
                TREATMENT_OPTION_UPGRADE: '( Treatment Plan upgrade to TrioClear {{status_param1}} )',
                ADDITIONAL_INFORMATION: 'Additional Information - {{status_remarks}}',
                PENDING: 'Pending',
                NOTED: 'Noted',
                RETRACK: 'Doctor Requested ReTrack',
                RETRACK_END: 'ReTrack {{status_param1}}',
                VIEW_RETRACK: 'View ReTrack',
                VIEW_RESTORATION_TOOL_FORM: 'View Restoration Tool Form',
                VIEW_RESTORATION_TOOL_FORM_FIRSTFIT: 'View Restorative Phase Order',
                RETRACK_REQUEST: 'Doctor Requested ReTrack',
                VIEW_MOCKUP_FEEDBACK:'View Mock-up Feedback',
                RETRACK_CANCEL: 'ReTrack Cancelled',
                RETRACK_FINISH: 'ReTrack Finished',
                VIEW_MOCKUP_ORDER:'View Mock-up Order',
                MOCKUP_ORDER:'Doctor Requested: Biofunctional Mock-up - {{product_label}} (Request {{status_param1}})',
                RESTORATION_TOOL_FORM_SUBMITTED_LOG_FIRSTFIT:'Our team will contact you via email to follow up on your order',
                RESTORATION_TOOL_FORM_SUBMITTED_LOG:"Our team will email you to follow up your \'Restorative Phase\' order",
                caseStatusLabel: {
                    RETRACK_CANCEL: 'ReTrack CANCEL',
                    RETRACK_FINSIH: 'ReTrack FINISH',
                    RETRACK_REPORT: 'ReTrack Report',
                    RETRACK_CONTINUE: 'ReTrack Continue',
                    RETRACK_DELIVERED: 'ReTrack Delivered',
                    RETRACK_PRODUCTION_IN_PROGRESS: 'ReTrack Production In Progress',
                },
                DOCTOR_REQUEST: 'Doctor Requested',
                FINISHING_CHARGEABLE_RETAINER: 'Finishing Retainer',
                FINISHING_RETAINER: 'Finishing Retainer',
                FINISHING_BLEACHING_TRAY: 'Finishing Bleaching Tray',
                DELIVERED: 'Delivered',
                VIEW_RETRACK_REPORT: 'View ReTrack Report',
                RETRACK_REPORT:
                    'ReTrack Report uploaded, please wait for aligner sets step {{status_param1}} to {{status_param2}}',
                RETRACK_REPORT_NULL: 'ReTrack Report uploaded, TrioClear aligner sets work well.',
                RETRACK_PRODUCTION_IN_PROGRESS: 'ReTrack Production In Progress',
                RETRACK_CONTINUE: 'Doctor Requested Continue ReTrack',
                RETRACK_END_REFINEMENT:
                    'Retrack Report uploaded. Due to {{status_remarks}}, this ReTrack will be turn to Refinement to solve the off-track.',
                viewFullDesignDocument: 'View Full Design Document',
                SMILE_DESIGN_VIEWER: 'I.S.D. Viewer',
                DESIGN_SIMULATION: 'Design Simulation',
                RETRACK_END_REASON: {
                    of: 'of',
                    is: 'is',
                    choice: {
                        Translation: 'Translation',
                        Intrusion: 'Intrusion',
                        Extrusion: 'Extrusion',
                        Crown_Tipping: 'Crown Tipping',
                        Crown_Torguing: 'Crown Torguing',
                        Rotation: 'Rotation',
                        IPRs: 'IPRs',
                        Attachments: 'Attachments',
                        Buttons: 'Buttons',
                        length: 'mm behind our plan',
                        angle: 'degree behind our plan',
                        attachment: 'need to add',
                    },
                    option: {
                        newToothShapeDetected:
                            'The software detected at least 1 new tooth shape (ex. New restoration or erupting teeth). Retrack is not eligible. Please submit Refinement.',
                        iprNotInAccordance:
                            'The software detected too many regions of IPR not in accordance with the approved treatment plan. Retrack is not eligible. Please submit Refinement.',
                    },
                },
                RETRACK_PRODUCTION_IN_PROGRESS_DELIVERED:
                    'ReTrack Aligner Set {{status_param1}} - {{status_param2}} will be produced and delivered',
                RETRACK_DELIVERED: "ReTrack is finished.Please go to 'Actions' list for your next action.",
                DIFF_RETAINER_REQUESTED: 'Doctor Requested {{type}} Retainer',
                RETAINER_REQUEST_PRODUCTION: '{{retainer}}: Production in Progress',
                RETAINER_REQUEST_DELIVERED: '{{retainer}} Delivered',
                approved: 'Approved',
                uploaded: 'Uploaded',
                approveiDesign2AndSmileDesign: 'iDesign 2.0 simulation plan & smile design plans',
                approveSmileDesign: 'Smile Design plans',
                DIFF_DR_RETAINER_REQUESTED: 'Doctor Requested:',
                DIFF_DR_RETAINER_REQUESTED_REF: 'Request {{retainer_no}}',
                REMINDER_DETAILS: 'Reminder Details',
                VIEW_DETAILS: 'View Details',
                UPGRADE_REQUEST: 'Upgrade request',
                RETRACK_ALL_MATERIAL_RECEIVED:
                    'All materials have been confirmed and the retrack report is expected to be delivered on {{status_param1}} {{status_param2}}',
                RETRACK_AWAITING: 'Awaiting more record',
                CHANGE_REQUEST_EXPECTED_DATE:
                    'The Treatment Plan is under modification and the revised plan is expected to be available on {{status_param1}} {{status_param2}}',
                MANUFACTURE_DETAIL: 'Manufacture Detail',
            },
            case_info: {
                selfDesign: {
                    noTreatmentPlan: 'No treatment plan found for this case.',
                    noTreatmentPlanForPlanNo: 'No treatment plan found for the given plan number.',
                    noSelfDesignRecord: 'No self design record found for this treatment plan.',
                    loadingFailed: 'Failed to load self design data. Please try again.',
                },
                manufactureDetail: {
                    title: 'Manufacture Request',
                    alignerSet: 'Aligner Set',
                    stepNumber: 'Step Number',
                    arch: 'Arch',
                    attachmentTemplates: 'Attachment Templates',
                    passiveAligner: 'Passive Aligner',
                    ecodontRetainer: 'Ecodont® Retainer',
                    trimline: 'Trimline',
                    trimlineScallopCutting: 'Scallop Cutting',
                    trimlineGingivalCoverCutting: 'Gingival Cover Cutting',
                    number: 'Number',
                    close: 'Close',
                    upper: 'Upper',
                    lower: 'Lower',
                    loadingFailed: 'Failed to load manufacture detail. Please try again.',
                },
                manufactureSummary: {
                    title: 'Approving Treatment Plan and Manufacture',
                    itemLabel: 'Item',
                    item: 'TrioClear Self-Design Aligner Treatment',
                    pricePerAligner: 'Price per aligner',
                    pricePerPassiveAligner: 'Price per passive aligner',
                    pricePerAttachmentTemplate: 'Price per attachment template',
                    pricePerRetainer: 'Price per retainer',
                    totalManufacturingSteps: 'Total manufacturing steps',
                    totalManufacturingStepsUnit: 'steps',
                    totalAligners: 'Total number of aligners',
                    totalPassiveAligners: 'Total number of passive aligners',
                    totalAttachmentTemplates: 'Total numbers of attachment templates',
                    totalRetainers: 'Total number of retainers',
                    alignersUnit: 'aligners',
                    upperLabel: 'Upper',
                    lowerLabel: 'Lower',
                    totalCostOfAligners: 'Total cost of aligners',
                    totalCostOfPassiveAligners: 'Total cost of passive aligners',
                    totalCostOfAttachmentTemplates: 'Total cost of attachment templates',
                    totalCostOfRetainers: 'Total cost of retainers',
                    shippingAndHandling: 'Shipping & Handling',
                    expressCourier: 'Express Courier',
                    totalShipmentFee: 'Total shipment fee',
                    grandTotal: 'Grand Total',
                    footnote:
                        'If you encounter any defects in the aligners you received, kindly reach out to your local TrioClear distributor.',
                    cancel: 'Cancel',
                    confirm: 'Confirm',
                    loadingFailed: 'Failed to load manufacturing summary. Please try again.',
                    pricingUnavailable:
                        'Pricing is not available for this distributor. Please contact your local TrioClear distributor.',
                    approveFailed: 'Failed to approve treatment plan. Please try again.',
                    approveSuccess: 'Treatment plan approved successfully.',
                },
                actionsList: {
                    requestFinishingRetainer: 'Request Finishing Retainer',
                    RequestChargeableBleachingRetainer: 'Request Chargeable Bleaching Retainer',
                    viewDefectPhotos: 'View Defect Photos',
                    updateStatus: 'Update Status',
                    lostReplace: 'Lost / Replace Aligners',
                    endCase: 'End Case',
                    archiveCase: 'Archive Case',
                    unarchiveCase: 'Unarchive Case',
                    refinement: 'Refinements',
                    requestRetainer: 'Request Ecodont™️ Retainers',
                    processNext: 'Order The Next Set of Aligners',
                    defectResubmit: 'Defect: Resubmit Case',
                    additionalInformation: 'Additional Information',
                    retrack: 'ReTrack',
                    orderNewMockUp: 'Order New Mock-up',
                    restorativePhase: 'Enter Restorative Phase',
                    requestRetainerBtn: 'Request Retainers',
                    createNewCaseForPatient: 'Create New Case For Patient',
                    redeemFinishingRetainer: 'Redeem Finishing Retainer',
                    orderNewRetainers: 'Order New Retainers',
                    startDesigningSelfDesign: 'Start Designing TrioClear Self-Design',
                    reviseDesignSelfDesign: 'Revise Design in TrioClear Self-Design',
                    approveTreatmentPlanAndManufacture: 'Approve Treatment Plan and Manufacture',
                    approveTreatmentPlanAndManufactureApproved: 'Approved',
                    orderNextOrReviseSelfDesign: 'Order Next Set of Aligners / Revise Design in TrioClear Self-Design',
                },
                documentsList: {
                    downloadRFSFile: 'Download RFS',
                    updateDefectiveImpressionAlertImage: 'View Defect Photos',
                    viewTreatmentPlan: 'View Treatment Plans',
                    clinicalSimulation: 'Trio iDesign™ and Live Support',
                    viewPhotos: 'View Photos',
                    printOrder: 'Print Order Information',
                    viewRadiograph: 'View Radiographs',
                    viewImpression: 'View Impressions',
                    viewQuestionnaire: 'View Prescription Notes',
                    viewDefectPhotos: 'View Defect Photos',
                    itemRequested: 'Item Requested',
                    smileDesignViewer: 'I.S.D. Viewer',
                    liveSupport: 'Live Suppport',
                    viewFullDesignDocument: 'View Full Design Document',
                    iDesignSimulation: 'iDesign Simulation',
                    clinicalSimulationSelfDesign: 'Design Simulation',
                },
                filesList: {
                    uploadDefectPhotos: 'Upload Defect Photo',
                    uploadConvertedMyp: 'Upload Converted MYP File',
                    uploadTreatmentPlan: 'Upload Treatment Plan',
                    uploadPhotos: 'Upload Photos',
                    uploadRadiograph: 'Upload Radiographs',
                    uploadImpression: 'Upload Impressions',
                    uploadQuestionnaire: 'Upload Prescription Notes',
                    waitingUploadIdesign: 'Waiting upload IDESIGN 2.0 from Jay',
                },
                caseStatus: 'Case Status',
                currentStatus: 'Current Status',
                chnageStatusTo: 'Change Status To',
                dob: 'Date of Birth',
                gender: 'Gender',
                remarks: 'Remarks',
                treatmentOption: 'Treatment Option',
                confirmedTreatmentOption: 'Confirmed Treatment Option',
                approvalDate: 'Approval Date',
                treatmentEndDate: 'Case Expiration Date',
                packageVersion: 'Package Version',
                caseLog: 'Case Log',
                actions: 'Actions',
                documents: 'Documents',
                uploadFiles: 'Upload Files',
                editInfo: 'Edit Info',
                clientCode: 'Client Code',
                refCode: 'Case Reference Code',
                kline: 'K-line Access',
                inputMessage: 'Input Message (Max 300 characters)',
                emailToDoctor: 'email to Doctor',
                internalRemarks: 'Internal Remarks',
                distributorInternalRemarks: 'Distributor Internal Remarks',
                promotionCode: 'Promotion Code',
                casesList: 'Cases',
                casesListCaseId: 'Case ID',
                patientId: 'Patient',
                caseId: 'Case',
                freeRefinementExpiryDate: 'Free Refinement Expiration Date',
                freeRefinementQuotaRemaining: 'Free Refinement Quota Remaining',
                warranty_record: 'Free {{param}} within warranty',
                stepsPerFreeRefinement: '{{steps_number}} steps per Free Refinement',
                stepsInTotal: '{{steps_number}} steps in total',
                packageVersionTooltip:
                    '<strong>Treatment Package</strong><br/><br/><strong>Pre-2026</strong><br/>TrioClear cases approved before 1-January-2026, processed under the previous treatment packages.<br/><br/><strong>2026</strong><br/>TrioClear cases approved on or after 1-January-2026, incorporating the new treatment package launched on that date.',
                facialScanData: 'Facial Scan Data',
                drRemarks: 'Dr\'s Note',
                manageNotes: 'Edit',
                readMore: 'read more',
                readLess: 'read less',
            },
            modals: {
                reminder: 'Reminder: Attachments must be removed prior to delivering the finishing retainer.',
                requestFinishingRetainerMessageStep1Withdraw:
                    'To withdraw consent in the future, Please send a written request to <a href=\\"mailto:cs@trioclear.com\\">cs@trioclear.com</a>.',
                requestFinishingRetainerMessageSubStep4: {
                    1: 'Finishing photos and new impression scans of the patient must be provided to claim the finishing retainer. The patient’s photos will only be used for internal record purposes by TrioClear. For further information, contact your local sales representative.',
                    2: 'Inaccurate or incomplete submissions may result in delays or rejection of your request.',
                    3: 'For further inquiries, please contact your local sales representatives',
                },
                prescriptionNotesModalTitle: 'Prescription Notes',
                rfsModalTitle: 'RFS Files',
                viewDefectPhotos: 'View Defect Photos',
                uploadedAt: 'Uploaded at',
                download: 'Download',
                photoModalTitle: 'Photos (Various Angle)',
                radioModalTitle: 'Radiographs',
                impressionModalTitle: 'Impression',
                questionnaireModalTitle: 'Questionnaire',
                reatinerModalTitle: 'Request Retainer',
                lostReplaceAlignersTitle: 'Lost / Replace Aligners',
                infoModalTitle: 'Patient Info',
                distortionLevelModerate: 'Distortion level: Moderate',
                distortionLevelSevere: 'Distortion level: Severe',

                ray_draft_file_modified: 'Ray scan files have been updated by DR',
                requestChargeableFinishingRetainerMessageStep1: {
                    1: 'I understand and agree to submit the patient’s photos to Perfection Aligner System Hong Kong Limited (according to the instructions listed in the photo guide). I hereby grant permission to TrioClear to use the submitted photos for internal study purposes.',
                    2: 'For further inquiries, please contact your local sales representative.',
                    3: '<strong>Reminder: Attachments must be removed prior to delivering the finishing retainer.</strong>',
                },
                retrackQuotaReminder: {
                    1: 'Please note that the free ReTrack quota for the selected treatment option has been fully used. This ReTrack will incur an additional fee.',
                    2: 'For further information, Please contact your local TrioClear customer support team.',
                },
                refinementQuotaReminder: {
                    1: 'Please note that the free Refinement quota for the selected treatment option has been fully used. This Refinement will incur an additional fee.',
                    2: 'For further information, Please contact your local TrioClear customer support team.',
                },
                question: {
                    retrack: {
                        1: {
                            text: 'Fill in the current step(s) of patient’s clear aligners*:',
                            remark: '*Mandatory field(s)​',
                        },
                        2: {
                            text: 'Please indicate which teeth is not tracking',
                        },
                        3: {
                            text: 'Please select residual space between 2 teeth if there is any',
                        },
                        error: {
                            upper: 'Please insert value in upper',
                            lower: 'Please insert value in lower',
                            photo: 'Please upload at least one photo',
                            teethNotTrack: 'Please select teeth not track',
                        },
                    },
                },
                retrackOldCase: {
                    1: 'Request for ReTrack',
                    2: 'You can contact your local sales representatives in the Chatbox for the complimentary ReTrack that remains in this TrioClear case.',
                    3: 'For new case submissions, the same information will be directly displayed in the Patient Details section.​',
                },
                refinementOldCase: {
                    1: 'Request for Refinement',
                    2: 'You can contact your local sales representatives in Chatbox for the complimentary Refinement remains in this TrioClear case.​',
                    3: 'For new case submissions, the same information will be directly displayed in the Patient Detail section.​',
                },
                requestFinishingRetainerMessageStep: {
                    noSpace:
                        'I understand and agree to submit the patient’s photos to Perfection Aligner System Hong Kong Limited (according to the instructions listed in the photo guide) to order a complimentary finishing retainer or bleaching tray. I hereby grant the permission to TrioClear intend to use the submitted photos for internal study purposes. If I wish to withdraw my consent in the future, I may do so with a written request to <a href=\\"mailto:cs@trioclear.com\\">cs@trioclear.com</a>.',
                },
                requestFinishingRetainerMessageStep1: {
                    1: "<div>The Finishing Retainer is free of charge with no warranty upon the submission of photos and scan files of the patient. It provides short term retention to maintain the stability of TrioClear patients' smiles. The retainer supports the final stages of treatment, helping the teeth settle into their new positions while minimizing relapse risk.</div> <br/><strong>Please order the EcoDont Retainer if you wish to provide your patients with long lasting retention.</strong>",
                    2: "I understand and agree to submit the patient's photos to TrioClear (according to the instructions listed in the photo guide). I hereby grant permission to TrioClear to use the submitted photos for internal study purposes.",
                    3: 'For further inquiries, please contact your local sales representative.',
                    4: '<strong>Reminder: Attachments must be removed prior to delivering the finishing retainer.</strong>',
                },
                caseExpired:
                    'This case has expired. Please start a new case for any additional requests. Please note that an expired case is no longer eligible for refinement or additional options.',
                caseExpiredWithinOneMonth:
                    'This case will expire within 1 month. After your case expires, please start a new case for any additional requests. Please note that an expired case is no longer eligible for refinement or additional options.',
                drRemarksModalTitle: "Doctor's Note",
            },
            caseStatusLabel: {
                DEFECT_RESPONDED: 'Defective Impression image: {Remark: ?} impression request',
                DEFECT_UPLOADED:
                    '{No.2 ?} Defect on Impression or Scan. Please open Design Simulation for further actions',
                DEFECT_RESUBMIT: 'Defect Resubmit Prescription Received',
                SUBMITTED: 'Prescription Submitted',
                SELF_DESIGN_SUBMITTED: 'Patient Information Submitted',
                AWAITING: 'Awaiting More Records{Remark: ?}',
                RECEIVED: 'Confirmed All Materials Received',
                CHANGE_REQUEST: 'Treatment Plan Change Request Received',
                PLAN_UPLOADED: 'Treatment Plan {No.?} Uploaded',
                PLAN_APPROVED: 'Treatment Plan {No.?} Approved',
                PRODUCTION: 'Production In Progress',
                DELIVERED: 'Aligners Set {No.1 ?}-{No.2 ?} Delivered',
                SELF_DESIGN_DELIVERED: 'Aligners Batch {No.1 ?} Delivered',
                NEXT_SET_REQUEST: 'The Next Aligner Set Ordered',
                ALL_DELIVERED: 'All Aligners Sets Are Delivered',
                ALIGNER_REQUEST: 'Aligner Request',
                RETAINER_REQUEST: 'Retainer Request',
                REFINEMENT: 'Refinements Prescription Received',
                ENDED: 'Case Ended',
                RETRACK_CANCEL: 'ReTrack CANCEL',
                RETRACK_FINISH: 'ReTrack FINISH',
                RETRACK_END: 'ReTrack {{status_param1}}',
                RETRACK: 'ReTrack',
                RESTORATION_TOOL_FORM_SUBMITTED: 'Restoration tool form submitted',
                UPGRADE_REQUEST: 'Upgrade request',
            },
            msg: {
                caseHasBeenEnded: 'This case has been ended by doctor, no files should be uploaded afterwards.',
                termsAndCondChecked: 'By clicking Submit means you have checked',
                termsAndCondCheckedLink: 'terms and conditions',
                archiveCaseDialogTitle: 'Archive Case?',
                unarchiveCaseDialogTitle: 'Unarchive Case?',
                endCaseDialogTitle: 'End Case?',
                confirmArchiveCase: 'Are you sure you want to Archive Case?',
                confirmUnarchiveCase: 'Are you sure you want to Unarchive Case?',
                confirmEndCase: 'Are you sure you want to End Case?',
                retrackTip: {
                    1: 'The ReTrack function allows TrioClear providers to submit a new scan of the patient’s existing dentition to address minor off-tracking issues. The TrioClear team will make the next sets of aligners by using the new scan data and the most recently approved treatment plan. If you wish to change the treatment plan approved previously (e.g. make new comments), please use the Refinement function instead.​',
                    2: 'TIP: Although no attachment template will be given, the clinician can consider free-hand building an attachment on the offtrack teeth before providing the new impression/scan.',
                },
                caseCancelledTitle: 'This Case Has Been Cancelled',
                caseCancelledMessage: 'This case has been cancelled.',
                selfDesignCaseTitle: 'Invalid Case Type',
                selfDesignCaseMessage: 'Clinical Simulation is not available for Self-Design cases.',
                smileDesignTip: 'This feature is coming soon. Stay Tuned!',
                commentTip:
                    'Please note you can submit only 1 comment per each treatment plan, with the option to edit them within 15 minutes after submission.',
                chargeFeeForReplacement:
                    'This section is for patients that have lost or damaged their aligners. A fee will be charged for replacement.',
                invalidCaseIdTitle: 'Invalid Case ID',
                invalidCaseIdMessage: 'The Case you have entered does not exist. Please check and try again.',
                duplicateCaseSubmissionTitle: 'This Case Is Being Processed',
                duplicateCaseSubmissionMessage: 'Case submission is being processed',
                cbctDownloadPreparing: 'The server is preparing your download. Please wait.',
                cbctDownloadFailed: 'Failed to download the file. Please try again later.',
                cbctDownloadNotFound:
                    'The file could not be found on the server. Please try again later or contact support.',
                cbctDownloadForbidden: 'You do not have permission to download this file.',
                cbctDownloadServerError:
                    'The server encountered an error while preparing your download. Please try again later.',
            },
            breadcrumbs: {
                caseManagement: 'Case Management',
                patient: 'Patient',
                doctor: 'Doctor',
                clinicalSimulation: 'Clinical Simulation',
                retainers: 'Retainers',
            },
            aligner: {
                addOneMore: 'Add One More',
                deleteThisRow: 'Delete This Row',
                replacement: 'Replacement',
                alreadyExists: 'Selected pair already exists,please choose other',
                duplicatePair: 'Duplicate Pair',
                stepNumber: 'Step Number',
                thickness: 'Thickness',
                arch: 'Arch',
                upper: 'Upper',
                lower: 'Lower',
                upperAndLower: 'Upper And Lower',
            },
            treatmentPlan: {
                noTreatmentPlan: 'No treatment plan is uploaded',
                undoPlanApproval: 'Undo Plan Approval',
                approvePlan: 'Approve Plan',
                reviewDesign: 'Review Design',
                designSimulation: 'Self-Design Simulation',
                fileName: 'File Name (Click to Download)',
                submissionDate: 'Submission Date',
                approved: 'Approved',
                approvedDate: 'Approved Date',
                view_3DSimulation: 'Trio iDesign™',
                dragAndDrop: 'Drag And Drop',
                pdfFile: 'PDF file',
                analysis: 'Analysis',
                treatmentPlan: 'Treatment Plan',
                videoFile: 'Video file',
                buccalViewVideo: 'Buccal View Video',
                occlusalVideo: 'Occlusal Video',
                uploadTreatmentOption: 'Upload Treatment Option',
                upperCycle: 'Upper Cycle',
                lowerCycle: 'Lower Cycle',
                approveTc: 'I approve TC !!!',
                notApproveTc: "I don't approve Tc !!!!",
                TcQuestionInto:
                    'The original treatment option selected {param1} does not have enough aligners to reach this final result. Please upgrade the plan to TrioClear {param2} (Accept / Not Accept)',
                accept: 'Accept',
                notAccept: 'Not Accepted',
                myoFile: '.myo file',
                smileDesignPPT: 'PPT Design Proposal',
                exocadPre: 'EXOCAD PRE-TC teeth',
                exocadPost: 'EXOCAD POST-TC teeth',
                exocadPreStrong: '<p>EXOCAD <strong>PRE-TC </strong> teeth</p>',
                exocadPostStrong: '<p>EXOCAD <strong>POST-TC </strong> teeth</p>',
                fileTypeError: 'Please upload a {param1} file',
            },
            clinicalSimulation: {
                msg: {
                    nextSet: 'Are you sure you want to order the next set of aligners?',
                    noTreatmentPlan: 'No Treatment Plan',
                    noStlFiles: 'No STL Files Uploaded Yet',
                    FAILED_TO_DELETE_CHAT_MESSAGE_CID: 'Chatroom messages cannot be deleted after 5 minutes.',
                    FAILED_TO_DELETE_CHAT_MESSAGE_CID_ADMIN: 'Chatroom messages cannot be deleted after 4 hours.',
                },
                tabs: {
                    simulation: 'View 3D Simulation',
                    viewStl: 'View STL',
                    uploadStlFiles: 'Upload STL Files',
                },
                buttons: {
                    approveTreatmentPlan: 'Approve Treatment Plan',
                    processToNextSet: 'Order The Next Set of Aligners',
                    upper: 'UPPER',
                    lower: 'LOWER',
                    all: 'ALL',
                    anter: 'ANTER',
                    maxil: 'MAXIL',
                    mand: 'MAND',
                    right: 'RIGHT',
                    left: 'LEFT',
                    openLiveSupport: 'Live Support Ticket',
                },
                row: 'Row',
                addRow: 'Add Row',
                chat: {
                    caseStatusChanged: 'Case status changed',
                    newStatus: 'New status',
                    sendPlaceHolder: "Press 'Shift + Enter' for new line, 'Enter' to send",
                },
                modal: {
                    openLiveSupportTip:
                        'Live Support Chatbox is used for non-treatment planning related comments. For treatment plan changes/comments, please use change request box above.',
                    openLiveSupport:
                        'For all treatment plan change requests, please make your comments in the "Change Request" section, thank you.',
                    changeRequestReminderText:
                        'Please note you can submit only 1 request per each treatment plan, with the option to edit them within 5 minutes after submission.',
                    requestTwelveStepOption:
                        'Request a (14 steps) treatment plan simulation for pre-restorative alignment.',
                    requestTwelveStepInfo:
                        'There will be no additional charge for treatment plan simulation within 14 steps for the pre-restorative alignment.',
                    requestComprehensiveOption:
                        'Request or upgrade the treatment plan simulation for a comprehensive pre-restorative alignment.',
                    requestComprehensiveInfo:
                        'A comprehensive pre-restorative alignment treatment plan simulation may go beyond 14 steps. Additional charge will be incurred.',
                    requestComprehensiveInfo2: 'For more information, please contact your sales respresentative.',
                },
                toggles: {
                    photo: 'Photo',
                    exocad: 'I.S.D Viewer',
                    trioIDesign: 'Trio iDesign™',
                    switchTreatmentPlan: 'Switch Treatment Plan',
                },
            },
            markRead: 'Mark Read and Clear Notification',
            klineAccess: {
                disable: 'Are you sure to disable this case access right to the K-Line ?',
                enable: 'Are you sure to enable this case access right to the K-Line ?',
            },
            retainer_caseStatusLabel: {
                SUBMITTED: 'Prescription Submitted',
                AWAITING: 'Awaiting More Records{Remark: ?}',
                RECEIVED: 'Confirmed All Materials Received',
                CHANGE_REQUEST: 'Treatment Plan Change Request Received',
                PLAN_UPLOADED: 'Treatment Plan {No.?} Uploaded',
                PLAN_APPROVED: 'Treatment Plan {No.?} Approved',
                PRODUCTION: '{Remark: ?} Production In Progress',
                DELIVERED: '{No.1 ?}-{No.2 ?} Delivered',
                DELIVERED_V2: 'Retainer Delivered',
                NEXT_SET_REQUEST: 'The Next Aligner Set Ordered',
                ALL_DELIVERED: 'All {Remark: ?} Delivered',
                ALIGNER_REQUEST: 'Aligner Request',
                RETAINER_REQUEST: 'Retainer Request',
                REFINEMENT: 'Refinements Prescription Received',
                ENDED: 'Case Ended',
            },
            defect: {
                button: {
                    newImpression: 'Upload a new impression in the chatbox',
                    cycleOneOnly: 'Confirm the current impression and send cycle 1 only',
                    CycleOneToSix: 'Confirm the current impression and send cycles 1 to 6',
                },
                newImpression: {
                    wording: 'Recommended',
                    charge: 'No additional charge',
                },
                moderateDefect: '(MODERATE DEFECT LEVEL IDENTIFIED)',
                severeDefect: '(SEVERE DEFECT LEVEL IDENTIFIED)',
                CycleOneOnly: {
                    wording: 'Continue with defective data, but send only 1 st cycle to test fit.',
                    moderateCharge: 'No additional charge',
                    severeCharge: 'An additional charge',
                },
                CycleOneToSix: {
                    wording1: 'Continue with defective data, send all initial 1-6 cycles of aligners',
                    wording2: 'Not Recommended.',
                    charge: 'Note: If the aligners do not fit and a re-submission is necessary within the first 8 weeks, an additional fee will be incurred.',
                },
                actionSelect: 'Please select one of the following action below:',
                standDefectCat: 'Standard Defects Category',
                defectCatelog: {
                    scanShortGingival: 'Scan Defect_Short Gingival in Critical Area',
                    scanSevere: 'Scan Defect_Severe Distortion',
                    scanUnfixable: 'Scan Defect_Unfixable Defects',
                    otherTeethShape: 'Others_Teeth Shape TBC',
                    others: 'Others_Others',
                },
            },
            ThreeShape: {
                NoticeToLoginMessage: 'You are not logged in to 3shape yet. Please click to log in.',
            },
            OAuth: {
                NoticeToLoginMessage_panda_cloud_EU:
                    'You are not logged in to Eletra - EU yet. Please click to log in.',
                NoticeToLoginMessage_panda_cloud_EN:
                    'You are not logged in to Eletra - EN yet. Please click to log in.',
                ConnectTo: 'Connect to',
                Disconnect: 'Disconnect',
                ReloadPlatform: 'Reload Platform',
                Modal: {
                    Status: 'Status',
                    PatientName: 'Patient Name',
                    CaseName: 'Case Name',
                    CreatedDate: 'Created Date',
                    Select: 'Select',
                    SelectedAndAutoFillIn: 'Selected and Auto Fill In',
                    Search: 'Search',
                },
                NoticeToLoginMessage_oauth_platform: 'You are not logged in to',
                NoticeToLoginMessage_oauth_platform_end: 'yet. Please click to log in.',
                oauth_for_euro: 'Only for Europe',
                oauth_non_euro: 'Outside of Europe',
                ReloadPlatformMessage: "If the connection status does not display properly, click 'Reload Platform'",
            },
            retrackReport: {
                date: 'Date',
                caseId: 'Case ID',
                upper: 'Upper',
                lower: 'Lower',
                alignerStep: 'ALIGNER STEP USED FOR COMPARISON',
                alignerStepComparison: "Patient's Current Aligner",
                newScan: 'The closest match to the newest scan data is step number',
                greenText: "Step used for comparison (Green):(=Patient's Current Aligner)",
                pinkText: 'Newest Scan Data (Pink)',
                newScanApprovedTreatment: "New Scan Data's Closest Match to Approved Treatment Simulation",
                newScanApprovedTreatmentStep: 'Aligner Step',
                sentToClinicTherefore: 'Therefore, aligner step',
                sentToClinicTo: 'to',
                sentToClinic: 'will be sent to the clinic.',
            },
            smileDesign: {
                exocadPre: 'EXOCAD Smile Design Plan',
                exocadPost: 'EXOCAD Smile Design overlapping POST-TC teeth',
                downloadFullPTT: 'Download Full PPT Smile Design',
                restorativePhase: {
                    caseIntakeTitle: 'Restorative Phase — Case Intake',
                    ChangeRestorationSolution: 'Change the Restoration Solution?',
                    mockupStep: 'Mock-up Feedback',
                    prescriptionStep: 'Prescription Notes',
                    impressionStep: 'Impression',
                    mockupTitle: 'Restorative Phase - Mock-up Feedback',
                    prescriptionTitle: 'Restorative Phase - Prescription Notes',
                    impressionTitle: 'Restorative Phase - Impression',
                    stepThree: 'Integrative Smile Design - Step 3',
                    mockupDescription: 'Confirm the outcome of the chairside try-in before the restorative phase is released.',
                    prescriptionDescription: 'The restoration solution and elements have been carried over from the approved Integrative Smile Design planning, <br>you may still adjust the restoration order here before the case proceeds to production.',
                    impressionDescription: 'Upload the impressions required to complete the restorative phase.',
                    mockupQuestion: 'Does the mock-up look good, or are edits needed?',
                    remark: 'Remark',
                    optionalAppliances: 'Optional appliances',
                    optional: 'optional',
                    splintRemarkNotice: 'If a splint is selected, state the type of splint in the remark below.',
                    fitDesc: 'F.I.T. — Flowable Injection Technique™',
                    fitSubDesc: 'Includes vertical dimension increase post-ortho',
                    adjustmentsDescribe:'Describe the chairside adjustments',
                    productionRemarkPlaceholder: 'Additional production instructions...',
                    adjustmentScanNotice: 'A new intraoral scan is required. Upload the post-adjustment scan on the Impression step before submitting.',
                    adjustmentScanNoticeRemark:'The new scan becomes the reference used to adapt the smile design.',
                    toothShapeAdjustments: 'Section 1: Tooth shape adjustments (Post-try-in)',
                    mockupAdjustments: 'Section 2: Mock-up adjustments',
                    sectionOne: 'Section 1: Restoration',
                    sectionTwo: 'Section 2: Restoration details',
                    plannedRestorationSolution: 'Planned restoration solution?',
                    orthodonticPhase: 'Orthodontic phase',
                    fitType: 'F.I.T. type',
                    injectionLayers: 'Injection layers (1 or 2)',
                    fitShade: 'Shade of nano-filled injectable composite syringes',
                    additionalSyringes: 'Additional syringes',
                    additionalSyringesOptional: 'optional, with additional fee',
                    shareDesc: 'Each restoration zone is supplied with <b>one syringe</b> as standard. Use the fields below only to request <b>additional</b> syringes where needed.',
                    selectAll: 'select all that apply',
                    materialPreference: 'Material preference',
                    shade: 'Shade',
                    shadeHint: 'Select a material first — the shade guide follows the material.',
                    whenOptionSelected: '(When {option} is selected)',
                    selectShade: 'Select shade',
                    shadeInputPlaceholder: 'e.g. ND3, stump shade',
                    otherShadePlaceholder: 'e.g., 4M1, 5M2',
                    layerEnamel: 'Enamel Layer',
                    layerDentin: 'Dentin Layer',
                    layerEnamelOrDentin: 'Enamel or Dentin',
                    eachLayerOneSyringe: 'Each layer is supplied with one syringe.',
                    selectActiveShadeLayer: 'Select active shade layer',
                    otherShades: 'Other Shades',
                    maskingLinerMl: 'Masking Liner (ML)',
                    standardShades: 'Standard Shades',
                    opaqueShades: 'Opaque Shades',
                    translucentShades: 'Translucent Shades',
                    gcBleachShadeGuide: 'GC Bleach Guide',
                    vitaShadeGuide: 'VITA Shade Guide',
                    ezneerShadeGuide: 'Ezneer Shade Guide',
                    ipsEmaxShadeGuide: 'IPS e.max Shade Guide',
                    vitaClassicShadeGuide: 'VITA Classic Shade Guide',
                    vitaBleachedShadeGuide: 'VITA Bleached Shade Guide',
                    vitaSystem3dMasterShadeGuide: 'VITA System 3D-Master Shade Guide',
                    ipsEmaxBleachShadeGuide: 'IPS e.max Bleach Shade Guide',
                    prepStumpShade: 'Prep (stump) shade',
                    targetShade: 'Target shade',
                    materialSelection: 'Material selection',
                    specifyOtherOption: 'Please specify if your preferred option is not listed above',
                    translucencyLevel: 'Translucency level',
                    translucency: 'Translucency',
                    surfaceTexture: 'Surface texture',
                    surfaceFinishing: 'Surface finishing & characterization',
                    effectsToReproduce: 'Effects to reproduce',
                    cementationTray: 'Cementation Tray (Positioning Guide)',
                    cementationTrayOptional: 'optional, with additional fee',
                    designSpecifications: 'Design specifications?',
                    currentToothShade: 'Current tooth shade',
                    desiredFinalShade: 'Desired final shade',
                    materialChoice: 'Material choice',
                    shapeIncisalEdgeAlignment: 'Shape, incisal edge, alignment, characterization and any specific instructions for the veneers...',
                    ceramicVeneersManualDesc: 'Ceramic Veneers — Manual Veneer Placement',
                    ceramicVeneersGuidedDesc: 'IPS e.max® Guided Veneer Treatment',
                    options: {
                        preOrthodontic: 'Pre-orthodontic',
                        preOrthodonticDescription: 'Applied before orthodontic treatment',
                        postOrthodontic: 'Post-orthodontic',
                        postOrthodonticDescription: 'After ortho — includes vertical dimension increase',
                        fitWear: 'F.I.T. Wear',
                        fitWearDescription: 'Standard Flowable Injection Technique™',
                        fitVeneers: 'F.I.T. Veneers',
                        fitVeneersDescription: 'Veneers via F.I.T.',
                        oneLayer: '1 Layer',
                        oneLayerDescription: 'Either Enamel Or Dentin',
                        oneLayerTooltip: '1 F.I.T Stent for single layer application',
                        twoLayers: '2 Layers',
                        twoLayersDescription: 'Enamel and Dentin',
                        twoLayersTooltip: '2 F.I.T Stents; 1 layer for Enamel and 1 layer for Dentin',
                        maskingLiner: 'Masking Liner',
                        zirconia: 'Zirconia',
                        lithiumDisilicate: 'Lithium Disilicate',
                        zirneer: 'ZirNEER',
                        ezneer: 'Ezneer',
                        threeDPrintedVeneer: '3D Printed Veneer',
                        others: 'Others',
                        ipsEmaxCad: 'IPS e.max',
                        econLithiumDisilicate: 'Econ Lithium Disilicate',
                        ipsEmax: 'IPS e.max®',
                        low: 'Low',
                        medium: 'Medium',
                        high: 'High',
                        smooth: 'Smooth',
                        pronounced: 'Pronounced',
                        fullGlazing: 'Full glazing only',
                        stainingGlazing: 'Staining & glazing',
                        stainingGlazingDescription: 'Reproduces natural characterization',
                        ipsEmaxLayered: 'IPS e.max® layered',
                        increasedCervicalChroma: 'Increased Cervical Chroma / Saturation',
                        whiteSpots: 'White Spots',
                        crazeLines: 'Craze Lines / Crack-Line Effects',
                        incisalTranslucency: 'Incisal Translucency',
                        opalescenceEffects: 'Opalescence Effects',
                        haloEffects: 'Halo Effects',
                        otherCharacterization: 'Other custom characterization',
                        bleachingRetainer: 'Bleaching Retainer',
                        ecodontCombiRetainer: 'Ecodont® Combi Retainer',
                        veneerRetainer: 'Ecodont® Retainer with Veneer Shield',
                        ecodontRetainer: 'Ecodont® Retainer',
                        invisibleRetainer: 'Invisible Retainer',
                        splint: 'Splint',
                        mockupApproved: 'Approved',
                        mockupApprovedDescription: 'The mock-up is approved as designed.',
                        mockupAdjustmentRequired: 'Adjustment Required',
                        mockupAdjustmentRequiredDescription: 'The mock-up was modified chairside.',
                        yes: 'Yes',
                        no: 'No',
                    },
                },
                prescriptionNotes: {
                    question: {
                        plannedRestorationSolution: '2. Planned restoration solution?',
                        plannedRestorationSolutionRemark:"for a combination of restorative solutions, please indicate this in the remark.",
                        orthodonticTreatmentTiming:
                            'Is this Flowable Injection Technique™ performed pre- or post-orthodontic treatment?',
                        fitType: 'F.I.T. type (select all that apply)',
                        chooseDentalMorphology: 'Please choose dental morphology for anterior dentition',
                        selectTeethNotChangeFirstFit: 'Please select the teeth you wish to exclude from tooth movement.',
                        selectTeethNotChange: 'Please indicate which teeth NOT to move or treat (ex. ankylosed, implants etc.)',
                        selectTeethSimulationFirstFit:
                            '2. Please tick the element/teeth that you would also like to restore (integrate in the design)?',
                        selectTeethSimulation:
                            '2. Please tick the element/teeth that you would also like to restore (integrate in the design)?',
                        desiredMaxillaryMidlinePosition: 'Desired maxillary midline position?',
                        desiredMandibularMidlineRelationship: 'Desired mandibular midline relationship',
                        maxillaryMidlineAngulation: 'Maxillary midline angulation?',
                        midlineCorrectionInSimulation: '5. Midline Correction in Simulation?',
                        cantingInSimulation: 'Canting in Simulation?',
                        softTissueModification:
                            'May the designer incorporate soft-tissue modification (gingivectomy)?',
                        softTissueModificationNote:
                            'A separate gingivectomy guide will be produced and delivered alongside your design.',
                        teethReductionPreference: '6. Teeth Reduction Preferences?',
                        toolsToOrder: '1. Select the tools you would like to order?',
                        referenceTeethImage: 'Referece teeth image:',
                        remark: 'Remark',
                        increaseVerticalDimensionFirstFit: 'Increase Vertical Dimension? (specify per jaw, if any)',
                        increaseVerticalDimension: 'Increase Vertical Dimension? (Any increase will apply bilaterally)',
                        teethReductionPreference_buccalFacial: 'Teeth reduction preference for buccal/facial?',
                        teethReductionPreference_palatalLingual: 'Teeth reduction preference for palatal/lingual?',
                        preRestorativeAlignerSimulationRemark: 'Without an aligner simulation, the photographs on the next step are optional.',
                        verticalDimensionPosteriorRemark:
                            'If “Increase Vertical Dimension” is selected, the standard workflow will establish the prescribed vertical dimension before TrioClear treatment, followed by restorative treatment.',
                        preRestorativeAlignerSimulation:
                            'Would you also like to request a pre-restorative TrioClear aligner simulation?',
                    },
                    option: {
                        compositeRebuilding: 'Composite Rebuilding/Veneers (F.I.T.)',
                        ceramicVeneers: 'Ceramic Veneers',
                        squareRound: 'Square/Round',
                        squareSquare: 'Square/Square',
                        roundRound: 'Round/Round',
                        shortSquareRound: 'Short Square/Round',
                        shortRound: 'Short Round/Round',
                        shortSquare: 'Short Square/Square',
                        flat: 'Flat',
                        round: 'Round',
                        pointed: 'Pointed',
                        verticalDimension: 'Onlay for Vertical Dimension Increase',
                        centrals: 'Centrals',
                        laterals: 'Laterals',
                        cuspids: 'Cuspids',
                        ul8: 'Upper and lower anterior 8',
                        u8: 'Upper anterior 8',
                        l8: 'Lower anterior 8',
                        allD: 'Full dentitions',
                        maintainExistingMidlinePosition: 'Maintain the existing position',
                        alignWithFacialReferenceLine: 'Align with the facial reference line',
                        coordinateWithPlannedMaxillaryMidline: 'Coordinate with the planned maxillary midline, where clinically feasible',
                        maintainExistingAngulation: 'Maintain the existing angulation',
                        correctCantToFacialVerticalReference: 'Correct the cant to the facial vertical reference',
                        customClinicianDefinedTarget: 'Custom clinician-defined target',
                        facialMidlineUpperOnly: 'Facial midline matching upper dental midline only',
                        facialMidlineUpperLower: 'Facial midline matching both upper and lower dental midline',
                        noMidline: 'No need to correct any midline',
                        noMidlineV1: 'Maintain existing midline',
                        maintainExistingCant: 'Maintain existing cant, if any',
                        correctCantingParallelToInterpupillaryLine: 'Correct canting to be parallel to interpupillary line',
                        correctCantingParallelToFloor: 'Correct canting to be parallel to the floor',
                        buccalFacial: 'Buccal/Facial',
                        noReduction: 'No reduction',
                        noPreference: 'No preference',
                        palatalLingual: 'Palatal/Lingual',
                        gingivalReductionGuide: 'Gingival Reduction Guide',
                        incisalPreparationGuide: 'Incisal Preparation Guide',
                        preparationCheckGuide: 'Preparation Check Guide',
                        indexFinalSimulationTemporization: 'Index of final simulation for Temporization',
                        temporaryRestorationRetainerAligner:
                            'Temporary Restoration (Choose Shade) (retainer with pontic/ aligner with shelf pontic)',
                        temporaryRestoration: 'Temporary Restoration (Choose Shade)',
                        bleachingTray: 'Bleaching Tray',
                        bleachingTrayPreOperation: 'Bleaching Tray for pre-operative situation',
                        notIncreaseVerticalDimension: 'Do not increase',
                        increaseVerticalDimension: 'Increase vertical dimension',
                        upperPosteriorFirstFit: 'Upper jaw',
                        lowerPosteriorFirstFit: 'Lower jaw',
                        upperArch: 'Upper arch',
                        lowerArch: 'Lower arch',
                        dualArch: 'Dual arch',
                        upperPosterior: 'Upper Posterior',
                        lowerPosterior: 'Lower Posterior',
                        formaInjectionTechnique: 'Forma Injection Technique',
                        flowableInjectionTechnique: 'Flowable Injection Technique™',
                        formaInjectionTechniqueFirstFit: 'F.I.T.',
                        flowableInjectionTechniqueFirstFit: 'F.I.T.',
                        flowableInjectionTechniqueDesc: 'Flowable Injection Technique™ — composite injected via clear stent',
                        formaInjectionTechniqueDesc: `Forma Injection Technique — composite injected via clear stent`,
                        preOrthodontic: 'Pre-orthodontic',
                        postOrthodontic: 'Post-orthodontic',
                        fitWear: 'F.I.T. Wear',
                        fitVeneers: 'F.I.T. Veneers',
                        no: 'No',
                        yes: 'Yes',
                        yesFirstFit: 'Yes (Additional design fee will apply)',
                        yesFirstFitSEA: 'Yes (Additional fee is applied to Gingivectomy Guide)',
                        fit: 'FIT',
                        veneers: 'Veneers',
                        crowns: 'Crowns',
                        formaRInjectionTechnique: 'Forma® Injection Technique',
                        ceramicVeneersCrowns: 'Ceramic Veneers / Crowns',
                        ceramicVeneersCrownsFirstFit: 'Ceramic Veneers',
                        ceramicVeneersCrownsDesc: 'Free hand prep and placement',
                        guidedVeneerTreatment: 'IPS e.max® Guided Veneer Treatment',
                        guidedVeneerTreatmentDesc: 'Guided Veneer workflow',
                        preRestorativeAlignerNo: 'No',
                        preRestorativeAligner14Step: 'Yes - Up to 14 steps (Free of charge)',
                        preRestorativeAlignerUnlimited: 'Yes - Unlimited steps simulation (Additional design fee will apply)',
                    },
                    section: {
                        Restoration: 'Section 1: Restoration',
                        Align: 'Section 2: Align',
                    },
                    note: {
                        preRestorativeAlignerSimulation:
                            'If “Increase Vertical Dimension” is selected, the standard workflow will establish the prescribed vertical dimension before TrioClear treatment, followed by restorative treatment.',
                    },
                },
                clinicalApprovement: {
                    option: {
                        approveiDesign2AndSmileDesign:
                            'I approve both iDesign 2.0 simulation plan and smile design plans. I want to enter TrioClear alignment phase now.',
                        approveSmileDesign:
                            'I approve smile design plans only. I want to enter restorative phase now. No TrioClear alignment process is needed.',
                        approveSmileDesignUpsell:
                            'I approve iDesign 2.0 simulation plan only. I want to enter alignment phase now. No restorative process is needed.',
                    },
                    Restoration:{
                        typeQuestion:'1. Restoration type?',
                        typeQuestionRemark:'For a combination of restorative solutions, please indicate this in the remark.',
                        SectionTwo:'Section 2: Restoration details',
                        orderBiofunctionalMockup: '2. Would you like to order a Biofunctional Mock-up?',
                        orderGingivectomyGuide: '3. Would you like to order a gingivectomy guide?',
                        mockUpmodel:'Changing the restoration type replaces the questions below and clears the answers already given. Continue?',
                        mockUpKeyOnly:'Yes — mock-up key only',
                        mockUpKeyAndMaterial:'Yes — Mock-up key + GC TempSmart™ Dual Cure (Cartridge)',
                        no:'No',
                        yes:'Yes',
                        materialShade:'Material shade',
                        gingivectomyGuide:'Vita Classical Shade Guide.',
                        gingivectomyGuideRemark:'Order a guide only where soft-tissue modification was planned in the Integrative Smile Design.',
                        mockUpKeyWithMockUpRemark:'A mock-up is strongly recommended before any irreversible preparation.',
                        Remark:'4. Remark',
                    },
                    upgradeTpOption: {
                        currentTpOption: 'The current treatment option',
                        description:
                            'You may upgrade the treatment option prior to starting this case, giving you more free refinement quota and a longer case expiration period. Please contact your sales representatives for more details.',
                        question: 'Would you like to explore an upgraded treatment option?',
                        optionNoApplicable: 'This option is not applicable',
                        notApplicable: 'Not Applicable',
                        title: 'Please select your preferred treatment option',
                        approveCurrentRadioBold: 'Approve',
                        approveCurrentRadioRest: 'the current treatment option',
                        upgradeRadioBold: 'Upgrade',
                        upgradeRadioRest: 'from the current treatment option (Newly selected package fee will be applied)',
                        currentRibbon: 'Current',
                        upgradeRibbon: 'Upgrade',
                    },
                },
                approveSmileDesignAndRestoration: 'Smile Design Plan Approved and Mock-up submitted',
                approveIDesignAndSmileDesign: 'iDesign 2.0 simulation plan and Smile Design plans approved',
                approveSmileDesignPlan: 'Smile Design Plan Approved',
                approveRestoration: 'Restoration Tool Form submitted',
                approveRestorationPhaseOrder: 'Restoration Phase Order Submitted',
                submitMockupOrder: 'Mock-up Order submitted',
                viewRestorationPhaseOrder: 'View Restoration Phase Order',
                mockupOrdering: {
                    title: 'Mock-up Ordering',
                    stepTwo: 'Integrative Smile Design - Step 2',
                },
                restorativeRedirectNotice:
                    "You will be redirected to the final prescription form. If not, click <strong>Enter Restorative Phase</strong> on the patient's dashboard.",
                downloadSmileReport: 'Download Smile Report',
                upperAnterior6: 'Upper Anterior 6',
                lowerAnterior6: 'Lower Anterior 6',
                upperLowerAnterior6: 'Upper and Lower Anterior 6',
                restorationFormRemindText: 'Please input shade, material request, occlusal preference etc',
                formaRInjectionTechniqueInfo: 'Powered by Elysee Modern Dental Europe / MD3D / HexaCeram',
                flowableInjectionTechniqueInfo: 'In collaboration with Modern',
            },
            ray_info: {
                ray_case: 'New Case submitted via Ray by',
                ray_refinement: 'Refinement Case submitted via Ray by',
                is_ray_case_no: 'No',
                is_ray_case_draft: 'Ray new case',
                is_ray_case_gallery: '3D Gallery',
                is_ray_refinement_no: 'No',
                is_ray_refinement_draft: 'Ray new Refinement',
                is_ray_refinement_gallery: '3D Gallery',
            },
        },
        NewPatient: {
            '3dFile': {
                choose3dVendor: 'Choose RayFace 3D facial data',
                '3dFacialDataGallery': '3D Facial DataGallery (Recommended)',
                '3dfacialDataisUploaded': '3d facial data is uploaded.',
                useFiles: 'Select File and Auto-fill Mandatory Photos',
                uploadedFromGallerySentence: '3D facial data is uploaded from RayFace 3D Facial Data Gallery.',
            },
            prescriptionNotes: {
                archToTreatPlaceholder: 'This field is required to proceed with the treatment plan design',
                noAttachmentAtAll: 'No attachment at all',
                noAttachmentAtAll_helperText:
                    'Please note that particular movements such as extrusion and major rotations are not possible without attachments',
                includedExcludedAttachments: 'Do NOT place / Do place attachments on these teeth',
                archToTreat: 'Arch to treat',
                both: 'Both',
                archToTreatUpper: 'Upper Only',
                archToTreatLower: 'Lower Only',
                excludedDentition: 'Please indicate which teeth NOT to move or treat (ex. ankylosed, implants etc.)',
                attachments: 'Attachments',
                placeAttachmentsAsNeeded: 'Place attachments as needed',
                excludedAttachments: 'Do NOT place attachments on these teeth',
                includedAttachments: 'Please do place attachments on following teeth',
                delayStage: 'Delay Step to Start IPR, attachments and extractions.',
                noDelay: 'No Delay',
                delayToStage: 'Delay to Step',
                alignersMarginPlacement: 'Aligner Gingival Coverage Preference',
                coverageExtending:
                    'Coverage extending to approximately 1.5mm past the gingiva (increased retention, less attachments)',
                scallopedAlignerMargins: 'Scalloped aligner margins (No gingival converage)',
                anteriorPosteriorRelationship: 'Anterior-Posterior (A-P) Relationship',
                right: 'Right',
                left: 'Left',
                learnMore: 'Learn More',
                maintain: 'Maintain',
                improveRelationship: 'Improve relationship',
                improveCanine: 'Improve canine relationship only',
                improveCanineAndMolar: 'Improve canine & molar relationship (Indicate specific teeth if necessary)',
                correctionToClassI: 'Correction to Class I (canine & molar)',
                spacingAndCrowding: 'Spacing & Crowding',
                spacing: 'Spacing',
                closeAllSpaces: 'Close all spaces',
                leaveSpecificSpaces: 'Leave specific spaces',
                editSpecificSpaces: 'Edit specific spaces',
                crowding: 'Crowding',
                resolveUpper: 'Resolve Upper',
                resolveLower: 'Resolve Lower',
                expand: 'Expand',
                procline: 'Procline',
                IPRAnterior: 'IPR - Anterior',
                IPRPosteriorRight: 'IPR - Posterior Right',
                IPRPosteriorLeft: 'IPR - Posterior Left',
                extraction: 'Extraction',
                primarily: 'Primarily',
                asNeeded: 'As needed',
                none: 'None',
                specificTeeth: 'Indicate specific teeth if necessary',
                willCheckiDesignOnceReleased: 'Will check iDesign once released',
                specifyWhichDirection: 'Specify which direction',
                overjet: 'Overjet',
                maintainInitialOverjet: 'Maintain initial overjet',
                improveResultingOverjetBy: 'Improve resulting overjet by:',
                noPreferenceShowResultsInSimulator: 'No preference, show results in Trio iDesign™ simulator',
                IPRANDRetraction: 'IPR & Retraction',
                transverseExpansionAndRetraction: 'Transverse expansion and retraction',
                combinationOfIPRAndTransverseExpansion: 'Combination of IPR & Transverse expansion',
                chooseHowYouWantToManageAnyOpenBite: 'Choose how you want to manage any open bite',
                openbite: 'Openbite',
                maintainInitialOpenbite: 'Maintain initial openbite',
                improveResultingOpenbiteBy: 'Improve resulting openbite by:',
                extrudeAnteriorTeeth: 'Extrude anterior teeth',
                upper: 'Upper',
                lower: 'Lower',
                intrudePosteriorTeeth: 'Intrude posterior teeth',
                placeMiniImplantsTAD: 'Place Mini Implants/TAD',
                deepBite: 'Deep bite',
                maintainExistingDeepBite: 'Maintain existing deep bite',
                improveResultingDeepBiteBy: 'Improve resulting deep bite by:',
                noPreference: 'No preference',
                intrudeAnteriorTeeth: 'Intrude anterior teeth',
                extrudePosteriorTeeth: 'Extrude posterior teeth',
                deepBiteRemark:
                    '*Attachments and occlusion/lingual bite ramps will be automatically added for selected extrusive/intrusive movements',
                midline: 'Midline',
                maintainInitialMidline: 'Maintain initial midline',
                improveResultingMidlineBy: 'Improve resulting midline by:',
                toPatientsRight: 'to patient’s right',
                toPatientsLeft: 'to patient’s left',
                posteriorCrossbite: 'Posterior Crossbite (if present)',
                maintainInitialCrossbite: 'Maintain initial crossbite',
                correct: 'Correction needed',
                noElastics: 'No Elastics',
                interarchElastics: 'Interarch Elastics (Recommended)',
                buttonPressedDirectlyOnAligner: 'Button pressed directly on aligner (Not recommended for 2nd molars)',
                maxillaryTeeth: 'Maxillary teeth',
                mandibularTeeth: 'Mandibular teeth',
                cutoutToBondButtonDirectlyOnTeeth: 'Cutout to bond button directly on teeth (Recommended)',
                otherMethods: 'Other methods:',
                cuttingOptions: 'Cutting Options',
                gingivalCutting: 'Gingival Cutting',
                scallopCutting: 'Scallop Cutting',
                auxiliaries: 'Auxiliaries',
                elastics: 'Elastics',
                classIIElastics: 'Class II Elastics',
                classIIIElastics: 'Class III Elastics',
                yes: 'Yes',
                no: 'No',
                ifYes: 'if yes',
                elasticEngagementPreference: 'Elastic engagement preference',
                upperDentition: 'Upper Dentition',
                lowerDentition: 'Lower Dentition',
                fabricateButtonDirectly: 'Fabricate button directly…',
                cutoutEngagementDirectly: 'Cutout engagement directly…',
                slipCutEngagementDirectly: 'SlitCut engagement directly…',
                cutout: 'Cutout',
                slipCut: 'SlitCut',
                otherElastics: 'Other Elastics (Rotation, Intrusion, Extrusion, Space Closure)',
                otherElasticsHintText: 'Please specify Other Elastics (Rotation, Intrusion, Extrusion, Space Closure).',
                fabricateButtonDirectlyOnAligners: 'Fabricate engagement directly on aligners',
                cutoutOnAligner: 'Cutout on aligner for bonding button directly on tooth',
                slipCutPrecisionCut: 'SlitCut (precision cut) on aligner for hooking elastics (only on canines)',
                useDimForces: 'Use Dim Forces on these teeth',
                orderTriobleachOption:
                    'Order Boutique Whitening Gel (4 syringes whitening gel of 16% Carbamide Peroxide)',
                specialInstructionsDescription: 'Add any patient specific special instructions',
                specialInstructions: 'Special Instructions',
                additionalInstructionsOrSpecialRequests: 'Additional Instructions / Special Requests',
                additionalInstructionsOrSpecialRequestsRemark:
                    '*Any comments in this Additional Instructions / Special Request section will take precedence over any selections made in the questions above.',
                additionalInstructionsOrSpecialRequestsPlaceholder:
                    'Please state your treatment preferences again so that we can develop a suitable plan. If you would like a maximum step limit, please indicate here.',
                inputYourRestorativePreferences: 'Input your restorative preferences',
                ieSpecificSpacing: '( i.e. specific spacing)',
                inputYourRequests: 'Input your requests -',
                ieNoIPRThisIsAnExpansionCase: 'i.e. (No IPR this is an expansion case)',
                referToBasicModuleELearningPlease: 'refer to basic module e-learning please.',
                locationOfTheSpacesYouWantToLeaveOpen: 'Location of the spaces you want to leave open.',
                requiredInformation: 'Required information.',
                attachmentTooltip: 'Please tick at least one of the graphs below.',
                trioDimForcePreference: 'TrioDim Force™ preference',
                trioDimForceDescription:
                    'is implemented in all TrioClear™ cases by our patented automation machine. Depending on the specific movement required, our software will design the divot at very specific locations according to the TrioDim Force™ principles. Every divot is measured and specifically placed with special instruments to ensure precision of the location. Below are a simple summary of different movements and the corresponding location of the divots.',
                trioDimForce_true:
                    'Automatically generate optional TrioDim Force™ divots on positions to enhance teeth movements based on the principles of TrioDim Force™ technology.​',
                trioDimForce_false: 'Do not include any TrioDim Force™ divots. ​',
                restorativeOptions: 'Increase vertical dimension before alignment',
                flowableInjection:
                    'Flowable Injection Technique™ (If a TrioClear treatment will be carried out, you will receive the F.I.T. package with the first batch of aligners at the same time.)',
                compositeOnlay: 'Composite onlay',
                flowableInjection_short: 'Flowable Injection Technique™',
                compositeOnlay_short: 'Composite onlay',
                upperPosterior: 'Upper Posterior',
                lowerPosterior: 'Lower Posterior',
                upperAndLowerInput: 'Please Select',
                upperAndLower: 'Upper and Lower',
                verticalDimensionQuestion: 'How much would you like to increase the vertical dimension',
                preImplantAligment: 'Pre-implant alignment',
                preImplantAligmentHint: 'Upright the following teeth for prosthetic space',
                addOnSmileDesign: 'Request an Integrative Smile Design™',
                integrativeSmileDesignReportTitle: 'Integrative Smile Design™',
                integrativeSmileDesignReportDescription:
                    '<b>Integrative Smile Design</b> includes a full smile analysis report and an exocad viewer of a proposed smile design of the final veneers/crowns. If also overlaps the pre and post TrioClear alignment.',
                referToDiagram: 'Please refer to the diagram',
                referToRemark: 'Please refer to the remark',
                resolveAsNeeded: 'Resolve upper & lower as needed. No Extractions',
                referToPreferences: 'Please refer to the specific preferences',
                fillSmileDesignForm:
                    'Please fill the Prescription Form of Integrative Smile Design in the next section.',
                notApplicable: 'Not applicable',
                onlayQuestion: 'Indicate tooth postion for F.I.T / Onlays',
                additionalFee: '*Additional fee will apply',
                restorativeOptionDelivery_no:
                    'No, will rescan after F.I.T/Onlay fitting for aligner production (movement same as already approved plan)',
                restorativeOptionDelivery: 'Send both F.I.T package/ Onlay together with first sets of aligners?',
                flowableInjection_info:
                    '(If a TrioClear treatment will be carried out, you will receive the F.I.T. package with the first batch of aligners at the same time.)',
                flowableInjection_tooltip_title: 'Flowable Injection Technique™ (F.I.T.)',
                flowableInjection_tooltip_content:
                    'The Flowable Injection Technique™ (FIT) is a direct, chairside dental method using flowable composite resin to rebuild tooth structure in a minimally invasive way. It involves flowable composite resin along with a transparent stent—a custom silicone index from a diagnostic wax-up—that guides precise injection and shaping. It can restore worn dentition, enhance esthetics, and increase vertical dimension of occlusion (VDO) by adding volume to occlusal, incisal, or buccal surfaces, making it efficient for anterior and posterior teeth with natural-looking results',
                moveTeethAsNeeded: 'Move any teeth as needed',
                notMoveTeeth: 'DO NOT move selected teeth. Please refer to the diagram',
                teethAttachmentContradiction:
                    'There is a contradiction in your attachment selections: the same tooth/teeth have been marked for both placement and non-placement. Please review and adjust one of the diagrams before proceeding.',
                includedExcludedAttachments_v2:
                    'Do / Do not place attachments on these teeth. Please refer to the diagram.',
                delayStage_v2: 'Delay IPR, attachments and extractions as details here.',
                leaveSpecificSpaces_v2: 'Leave specific spaces as detailed here.',
                resloveDetail: 'Resolve by the methods as detailed here.',
                noPreferenceShowResultsInSimulation: 'No preference, show results in Trio iDesign™ simulation',
                placeMiniImplantsTAD_v2: 'Place Mini Implants/TAD as detailed here.',
                correct_v2: 'Correction needed as details here.',
                otherElastics_v2:
                    'Other Elastics (Rotation, Intrusion, Extrusion, Space Closure): Needed as detailed here.',
                currentSteps: "Current step(s) of patient's clear aligners",
            },
            breadcrumbs: {
                treatmentOptionSelected: 'Treatment Option Selected',
                caseManagement: 'Case Management',
                newCase: 'New Case',
                reminder:
                    'Detailed instructions for each aligner case are essential to ensure accurate, customized treatment and to establish an appropriate treatment duration.',
                selfDesignReminder: 'Create patient profile first before starting self-design',
            },
            tabs: {
                prescriptionNotes: 'Prescription Notes',
                info: 'Patient Info',
                questionnaire: 'Questionnaire',
                delivery: 'Delivery',
                photos: 'Photos',
                impression: 'Impression',
                radiography: 'Radiographs',
                summary: 'Summary',
                newOrderForm: 'New Order Form',
                retainer_request_prescriptionNotes: 'Retainer',
                trioclearPrescriptionNotes: 'TrioClear Prescription',
                ISDPrescriptionNotes: 'I.S.D. Prescription',
                prescriptionNotesSD: 'I.S.D. Prescription Notes',
            },
            warning: {
                elastic: 'Class II and III Elastic cannot select both to Yes.',
                tooth: 'Please select at least one tooth.',
                value: 'Please select one value.',
                locationOfTheSpace: 'Please input location of the spaces you want to leave open.',
                checkbox: 'Please check at least one checkbox.',
                specifyArea: 'Please specify which area to place Mini Implants/TAD.',
                option: 'Please select one option.',
                otherMethods: 'Please specify other methods.',
                firstName: 'Please Provide Valid First Name',
                lastName: 'Please Provide Valid Last Name',
                city: 'Please Provide Valid City',
                postCode: 'Please Provide Valid Zip Code',
                phoneNo: 'Please Provide Valid Phone Number',
                allMandatory: 'Please upload all the necessary files or it would cause inaccuracy for treatment plans',
                mandatoryPhoto: 'Please upload ALL the mandatory photographs.',
                mandatoryRadiograph: 'Please upload ALL the mandatory radiographs.',
                allStl: "Please upload ALL the STL files or check the 'I will upload this photo later' boxes.",
                courier: 'Please provide Customer Pick-Up Code/ Doctor Code for impression.',
                scanner: 'Please provide Scanner Brand and Username/Login Name/Dr. Name for impression.',
                leaveWithoutSave: 'Are you sure you want to leave?',
                saveDraft: 'Please SAVE DRAFT if you want to edit later',
                accessories_quantity: 'At least one quantity item to input',
                replace_patient_profile_pic_title: 'Replace Profile Picture',
                replace_patient_profile_pic:
                    'Patient already has a profile picture. Do you want to replace it with the frontal photo?',
                prescription_notes: 'There are mandatory questions that have not been filled.',
                stepNumber: 'Please enter valid number for current patient step.',
                verticalDimensionQuestion: 'Please select how much you would like to increase the vertical dimension.',
                verticalDimensionQuestion_ToothArea: 'Please select tooth area for vertical dimension increase.',
                verticalDimensionQuestion_JawPosition: 'Please select jaw position for vertical dimension increase.',
                verticalDimensionQuestion_Increase:
                    'Please select how much you would like to increase the vertical dimension.',
                smile_design_prescription_notes:
                    'Please fill in all required fields in Smile Design Prescription Notes.',
                verticalDimensionPosterior: 'Please select at least one option',
                verticalDimensionMismatch:
                    'The vertical dimension posterior values in Q4 must match the values selected in Q14 (Prescription Notes). Please adjust your answer.',
                elastic_v2: 'You cannot select both Class II and Class III elastics. Please adjust your answer.',
                anterior_dentition:
                    'You can only select one dental morphology for anterior dentition. Please deselect the extra option.',
                archToTreat: 'Please select which arch to treat.',
                anteriorPosteriorRelationship:
                    'Please select Anterior-Posterior (A-P) Relationship for both left and right.',
                spacingAndCrowding: 'Please select spacing option and crowding resolution method.',
                auxiliariesElastics: 'Please select Class II Elastics, Class III Elastics, and Other Elastics options.',
                attachmentsRequired: 'Please select Attachments option and Delay Stage option.',
                guidedVeneerUploadScanGuidanceTitle: 'Guided Veneer Upload – Scan Guidance',
                guidedVeneerUploadScanGuidanceContent:
                    'To ensure a proper fit, please include at least <b>5 mm of gingival tissue</b> in the scan.',
            },
            questionnaire: {
                elastic: 'If elastics are needed which method of engagement would you like?',
                buttonPressd: 'Button pressed on the aligner',
                slip: 'Slip cut on the aligner',
                cutout: 'Cutout for direct button',
                bounding: 'Bounding to the teeth',
                trioclearAccessories: 'Trioclear Accessories',
                bleachingGel: 'Bleaching Gel',
                elastics: 'Elastics',
                button: 'Button',
                dentition_none: 'None',
                dentition_upper: 'Upper',
                dentition_lower: 'Lower',
                dentition_anterior: 'Anterior',
                dentition_posterior: 'Posterior',
                clinicalCondition: 'Clinical Condition',
                selectDentitionNotMove: 'Please select the dentition that you wish NOT to move',
                selectDentition: 'Please select the dentition that you wish NOT to move',
                gainSpaceMethod: 'Method of Gaining Space',
                overjet: 'Overjet',
                overbite: 'Overbite',
                midline: 'Midline',
                crossbite: 'Crossbite',
                comment: 'Comment',
                crowding: 'Crowding',
                deepBite: 'Deep Bite',
                spacing: 'Spacing',
                classII: 'Class II Division I',
                ClassIIDivI: 'Class II Division II',
                classIII: 'Class III',
                unevenSmile: 'Uneven Smile',
                openBite: 'Open Bite',
                other: 'Other',
                upper: 'Upper',
                lower: 'Lower',
                anterior: 'Anterior',
                posterior: 'Posterior',
                primary: 'Primary',
                secondary: 'Secondary',
                referToClinicalSimulation: 'Refer to Clinical Simulation',
                maintain: 'Maintain',
                improve1mm: 'Improve 1mm',
                improve2mm: 'Improve 2mm',
                improve3mm: 'Improve 3mm',
                improve4mm: 'Improve 4mm',
                improve5mm: 'Improve 5mm',
                correctUpper: 'Correct upper by 1-5 mm',
                correctLower: 'Correct lower by 1-5 mm',
                improve: 'Improve',
                extraction: 'Extraction',
                extractionWhich: 'Extraction (Which tooth to extract?)',
                expansion: 'Expansion',
                interproximalReduction: 'Interproximal Reduction',
                distalization: 'Distalization',
                proclination: 'Proclination',
            },
            NewCaseOption: {
                CaseOptionDescription: 'New Case Option Description',
            },
            navBtns: {
                next: 'Next',
                submit: 'Submit',
                previous: 'Previous',
                saveDraft: 'Save Draft',
            },
            info: {
                dragAndDrop: 'Upload patient profile picture (optional)',
            },
            photographs: {
                uploadThisPhotoLater: 'Upload this photo later',
                photographs: 'Photographs',
                flip: 'Flip',
                chooseFromYourGallery: 'Choose from your gallery.',
            },
            radiographs: {
                orthopantomogram: 'Orthopantomogram',
                lateralCephalogram: 'Lateral Cephalogram',
                uploadRadiograph: 'Upload the Radiographs',
                uploadCbct: 'Upload CBCT file',
                notUploadWarning: 'Not uploading strongly recommended file may cause error in final reports',
                cbct_dicom: 'CBCT DICOM',
            },
            impressions: {
                uploadImpression: 'Upload the impressions',
                uploadStlFilesLater: 'I will upload the STL files later',
                uploadStl: 'Upload STL Files',
                uploadByCourier: 'Physical Impressions by Courier',
                uploadByScanner: 'Digital Impressions Sent by Intraoral Scanner Portal',
                notUploadWarning:
                    'Treatment plan will not be started after submission unless all the STL files are received',
                byCourierLabel: 'Customer Pick-Up Code/ Doctor Code',
                byScannerBrandLabel: 'Scanner Brand',
                byScannerUserNameLabel: 'Username / Login Name / Dr. Name',
                doctorId: 'Doctor ID',
                uploadImpressionWarning: 'Please upload from unzipped folders only. Files must be >100KB.',
                label: {
                    FrontalExtraoralFacial: 'Frontal Extraoral Facial',
                    IntraoralRight: 'Intraoral Right',
                    IntraoralFrontal: 'Intraoral Frontal',
                    IntraoralLeft: 'Intraoral Left',
                },
            },
            delivery: {
                promotionCodeLabel: 'Enter a Promotion Code If Any',
                selectAddressLabel: 'Select a billing address or enter new address',
            },
            summary: {
                orderInfo: 'Order information',
                noCondition: 'No condition is selected',
                dentitionMove: 'Dentition that you wish to move',
                dentitionNotMove: 'Dentition that you wish NOT to move',
                allPhotos: 'All Photos',
                allRadiography: 'All Radiographs',
                allImpressions: 'All Impressions',
            },
            trioclear_app_notification: {
                case_log: {
                    title: 'CASE {#case_id} status has changed',
                    body: 'Please login to doctor submission portal if further action is needed. Case Log: {content}',
                },
                new_photo_upload_by_patient: {
                    title: 'New photos are uploaded by the patient',
                    body: 'Track the progress of CASE {#case_id}',
                },
                chatbox_new_messages: {
                    title: 'New message(s) from TrioClear !',
                    body: 'Unread message(s) alert - CASE {#case_id}. Please login to doctor submission portal to check the new message(s) in chatbox',
                },
                tracking_data_uploaded_by_patient: {
                    title: 'Wearing time statistics record is uploaded by patient',
                    body: 'Track the progress of CASE {#case_id}',
                },
            },
            Patient_select_tab: {
                new_patient: 'New Patient',
                existing_patient: 'Create new case from existing patient',
                existing_patient_list_Id: 'Patient ID',
                createAlignerCase: 'Create Aligner Case for Existing Patient',
                createSmileDesignCase: 'Create Smile Design Case for Existing Patient',
            },
            smileDesignNotCompleted: 'Smile Design Prescription Note is not completed',
        },
        NotificationDialog: {
            do_not_show_again: 'Do not show this again',
            new_feature_popup: {
                title: 'What is new in Trio iDesign™ Software',
                item1: {
                    title: 'CBCT Integration',
                    content: 'CBCT is now available in the treatment plan simulations.',
                },
                item2: {
                    title: 'Movement Difficulty Indicators',
                    content:
                        'Dot indicators in yellow and red denote larger tooth movements, which may pose greater difficulty in achieving the desired treatment outcome.',
                },
                item3: {
                    title: 'Combination View',
                    content: 'Users can now see the intraoral model in five different angles at the same time.',
                },
                item4: {
                    title: 'Overjet/Overbite Analysis',
                    content: '',
                },
                more_detail: 'For full details on Trio iDesign™ 2.0, please click here.',
                more_detail_link:
                    'https://pro.trioclear.com/file/formOrKnowledge?path=/knowledgeArticle/23/719f89e9e79b5c9703beddae7aad6c2e02ef2163.pdf&fileName=/Trio%20iDesign%202.0%20popup_20231208_EN.pdf',
            },
        },
        RequestFinishingRetainer: {
            '1setOfRetainers': '1 set of Retainers',
            bleachingTray: 'Bleaching Tray',
            usingExistingImpressionFiles: 'Use last step of the most recent approved treatment plan',
            newImpressionFiles: 'Submit new patient data',
            photosReminder:
                'Reminder: *Please upload standard orthodontic quality photos to successfully claim the finishing retainers*',
        },
        global: {
            const: {
                accept: 'Accept',
                notaccept: 'Decline',
                none: 'None',
                warning: 'Warning',
                close: 'Close',
                all: 'All',
                remove: 'Remove',
                uploading: 'Uploading',
                submit: 'Submit',
                update: 'Update',
                save: 'Save',
                saving: 'Saving',
                Proceed:'Proceed',
                login: 'Log In',
                loginInstead: 'Log In Instead',
                register: 'Register',
                replace: 'Replace',
                lost: 'Lost',
                type: 'Type',
                back: 'Back',
                yes: 'Yes',
                no: 'No',
                confirm: 'Confirm',
                cancel: 'Cancel',
                print: 'Print',
                ok: 'OK',
                reset: 'Reset',
                required: 'Required',
                technology: 'technology',
                Technology: 'Technology',
                updateVersion:
                    'Please update to the latest version ({{param}}) and refresh your browser before submitting new materials.',
                updateVersionReminder: 'For case submissions, save as a draft beforehand avoid data loss.',
                Reminder: 'Reminder',
                moreDetails: 'View Details',
                Left: 'Left',
                Right: 'Right',
                actionRequired: 'Unable to Proceed',
            },
            caseType: {
                FLEX: 'Flex',
                RECOMMEND: 'Recommend',
                TOUCHUP_PLUS: 'Touch Up +',
                TOUCH_UP: 'Touch Up',
                SIMPLE: 'Simple',
                COMPLETE: 'Complete',
                RETAINER: 'Retainer',
                CBCT: 'Cbct',
                ULTRA: 'Ultra',
                FULL_SMILE_DESIGN: 'Full Smile Design',
                SIMPLE_SMILE_DESIGN: 'Simple Smile Design',
                CHOOSE_LATER: 'Choose Treatment Option Later',
                SELF_DESIGN: 'Self-Design',
            },
            caseStatus: {
                DRAFT: 'Draft',
                SUBMITTED: 'Submitted',
                AWAITING: 'Awaiting',
                RECEIVED: 'Received',
                PLAN_UPLOADED: 'Plan Uploaded',
                CHANGE_REQUEST: 'Change Request',
                PLAN_APPROVED: 'Plan Approved',
                PRODUCTION: 'Production',
                DELIVERED: 'Delivered',
                NEXT_SET_REQUEST: 'Next Set Request',
                ALL_DELIVERED: 'All Delivered',
                ENDED: 'Ended',
                REFINEMENT: 'Refinement',
                DEFECT_UPLOADED: 'Defect',
                DEFECT_RESPONDED: 'Defect Responsed',
                DEFECT_RESUBMIT: 'Defect Resubmit',
                RETRACK_FINISH: 'ReTrack FINISH',
                RETRACK_CANCEL: 'ReTrack CANCEL',
                RETRACK_END: 'ReTracking Unsuccessful',
                RETRACK: 'ReTrack',
                RESTORATION_TOOL_FORM_SUBMITTED_FIRSTFIT: 'Restorative Phase Order Submitted​',
                RESTORATION_TOOL_FORM_SUBMITTED: 'Restoration Tool Form Submitted​',
                RETRACK_REPORT: 'ReTrack Report',
                RETRACK_CONTINUE: 'ReTrack Continue',
                RETRACK_DELIVERED: 'ReTrack Delivered',
                RETRACK_PRODUCTION_IN_PROGRESS: 'ReTrack Production In Progress',
                RETRACK_AWAITING: 'ReTrack Awaiting',
                RETRACK_ALL_MATERIAL_RECEIVED: 'ReTrack All Material Received',
                UPGRADE_REQUEST: 'Upgrade Request',
            },
            role: {
                ADMIN: 'Admin',
                DISTR: 'Distributor',
                GADMIN: 'Group Admin',
                CADMIN: 'Clinic Admin',
                DR: 'Doctor',
                NR: 'Nurse',
                SADMIN: 'Super Admin',
                KLINE: 'K-Line',
            },
            uploadType: {
                mandatory: 'Mandatory',
                stronglyRecommended: 'Strongly Recommended',
                uploadPhotoLater: 'I will upload this photos later',
                uploadXrayLater: 'I will upload this x-ray later',
                willNotUploadPhoto: 'Photo will not be uploaded',
                willNotUploadXray: 'I will NOT upload this X-ray',
                optional: 'Optional',
                free_angle_optional: 'Free angle (Optional)',
                ray_face_scan_info: 'A 3D facial scan improves smile-design accuracy.',
                ray_face_scan_import_info: 'Import your 3D facial scan directly from an available RayFace account.',
                ray_face_scan_connect_rayFace: 'Connect RayFace',
                selectRayFace3dScan: 'Select a RayFace 3D facial scan',
                DFacialScan: '3D Facial Scan',
            },
            dragAndDrop: {
                dragAndDrop: 'Drag And Drop',
                dropHere: 'Drop Here',
            },
            honorific: {
                mr: 'Mr.',
                ms: 'Ms.',
            },
            fields: {
                name: 'Name',
                firstName: 'First Name',
                lastName: 'Last Name',
                caseId: 'Case ID',
                gdprNotice: '*For EU Customers, please enter only initials or patient number due to GDPR',
                patient: 'Patient',
                gender: 'Gender',
                male: 'Male',
                female: 'Female',
                other: 'Other',
                title: 'Title',
                Prof: 'Prof.',
                Dr: 'Dr.',
                Mr: 'Mr.',
                Mrs: 'Mrs.',
                Ms: 'Ms.',
                Miss: 'Miss.',
                dateOfBirth: 'Date of Birth',
                dateOfBirthAbbr: 'DOB',
                day: 'Day',
                month: 'Month',
                year: 'Year',
                remarks: 'Remark for Lab',
                drRemarks: "Dr's Note",
                country: 'Country',
                stateProvince: 'State/Province',
                localEntity: 'Local Entity',
                city: 'City',
                address: 'Address',
                doctor: 'Doctor',
                deliveryAddress: 'Delivery Address',
                postCode: 'Zip/Postal Code',
                phoneNo: 'Phone Number',
                tel: 'Telephone',
                faxNo: 'Fax Number',
                promotionCode: 'Promotion Code',
                distributor: 'Distributor',
                email: 'Email',
                licenseNo: 'License No.',
                clinic: 'Clinic',
                clinicPhoneNo: 'Clinic Phone Number',
                clinicWebsite: 'Clinic Website',
                group: 'Group',
                radiographs: 'Radiographs',
                photos: 'Photos',
                impression: 'Impression',
                questionnaires: 'Questionnaires',
                treatmentPlan: 'Treatment Plan',
                date: 'Date',
                startDate: 'Start Date',
                endDate: 'End Date',
                password: 'Password',
                confirmPassword: 'Confirm Password',
                companyName: 'Company Name',
                refCode: 'Case Reference Code',
                doctorName: 'Doctor Name',
                devlieryName: 'Delivery Name',
                order_no: 'Order No',
                sourceFrom: 'Where do you hear about TrioClear',
                enableEmailNoti: 'Receive Email Notification',
            },
        },
        log: {
            DOCTOR_REQUEST: 'Doctor Requested',
            FINISHING_RETAINER: 'Finishing Retainers',
            FINISHING_BLEACHING_TRAY: 'Finishing Bleaching Tray',
            DELIVERED: 'Delivered',
        },
        'REFINEMENT_X_SUBMITTED=>REFINEMENT': 'REFINEMENT',
        'REFINEMENT_X_=>REFINEMENT': 'SUBMITTED',
        TrioclearMarketPlace: {
            newOrder: {
                back: 'Back',
                trioclearOrderForm: 'Trioclear Order Form',
            },
            trioclearOrderForm: {
                description: 'Description',
                price: 'Price',
                quantity: 'Quantity',
                summary: 'Trioclear Summary',
                total_price: 'Total Price',
                other_value: 'Other Value',
                message: 'Do you want to confirm your ordering from Trioclear Market place',
            },
            order_history: {
                order_history_screen: 'Order History Screen',
                action: 'Actions',
                order_status: 'Order Status',
                order_no: 'Order No.',
                submission_date: 'Submission Date',
                confirmed_date: 'Confirmed Date',
                delivery_date: 'Delivery Date',
                end_date: 'Closed Order Date',
                order_detail: 'Order Detail',
                live_chat: 'Live Chat',
                total_price: 'Total Price',
                search_placeholder: 'You can filter order no , order status , total price',
                country: 'Country',
                distributor: 'Distributor',
                clinic: 'Clinic',
                dr_name: 'Dr_name',
                confirm: 'Confirmed',
                delivered: 'Delivered',
                end_case: 'End Case',
                update_status: 'Updated Status',
            },
        },
        Footer: {
            weibo: '微信',
            trioclear_cn_name: '透舒丽',
            wechat: '微信公众号',
            followUs: 'Follow Us',
            facebook: 'facebook',
            instagram: 'instagram',
            customerService: 'Customer Service',
            contact:
                'We are always ready to serve you. If you are interested in TrioClear, you are welcome to contact our team at cs@trioclear.com',
            companyName: 'TrioClear®.',
            allRightsReserved: 'All Rights Reserved.',
            termsAndConditions: 'Terms & Conditions',
            privacyPolicy: 'Privacy Policy',
        },
        pages: {
            paitents: {
                markarchive: 'Mark Archive',
            },
            newpatient: {
                back: 'Back',
            },
            treatmentapproval: {
                something_went_wrong_please_connect_with_admin: 'Something Went Wrong Please Connect With Admin',
                are_you_sure_you_want_to_approve_this_treatment_plan:
                    'Are you sure you want to approve this treatment plan?',
                treatment_plan_uploaded: 'Treatment plan uploaded',
                treatment_plan_approval_is_undone: 'Treatment plan {No.1 ?} approval is undone',
                treatment_plan_status: 'Treatment plan {No.1 ?} Status:',
                approved: 'Approved',
                notapproved: 'Not Approved',
                treatment_plan_approved: 'Treatment plan {No.1 ?} approved',
                analysis: 'Analysis',
                treatment_plan: 'Treatment Plan',
                buccal_view_video: 'Buccal View Video',
                occlusal_view_video: 'Occlusal View Video',
                all_treatment_plans_by_date: 'All Treatment Plans (By Date)',
                latest_approved_plan: 'Latest Approved Plan',
                edit_plan: 'Edit Plan',
                first_production: 'First Production',
                refinement: 'Refinement',
                defect_resubmit: 'Defect Resubmit',
                smileDesignPPT: 'PPT Design Proposal',
                exocadDesign: 'I.S.D Viewer',
                smileReport: 'Smile Report',
            },
            PatientInfo: {
                DEFECT_UPLOADED:
                    '{{status_param2}} Defective Impression / Data Detected {{status_param1}} on {{status_remarks}}',
            },
        },
        Nav: {
            welcome: 'Welcome',
            caseManagement: 'Case Management',
            trioclear_marketplace: 'Trioclear Market Place',
            accountSummary: 'Account Summary',
            supportAndResources: 'Support and Resources',
            logout: 'Logout',
            changePassword: 'Change Password',
            dashboard: 'Dashboard',
            myAccount: 'My Account',
        },
        TopBar: {
            trioclearWebsite: 'TrioClear Website',
            contactUs: 'Contact Us',
            lang: 'Language',
        },
        Account: {
            accountChartTitle: 'Creation of New Accounts',
            accountChartSubtitle: 'By Week, Month, Year and Distributor, Group, Clinic, Doctor',
            caseChartTitle: 'Case Overview',
            caseChartSubtitle: 'By Month, Year and by All, Submitted, Draft',
            detailsTitle: 'Profile Details',
            addressTitle: 'Delivery Address',
            profileTabTitle: 'Profile',
            chartTabTitle: 'Chart',
            addressTabTitle: 'Delivery Address',
        },
        Support: {
            contactInfo: 'Contact Information',
            formDownload: 'Form Download',
            discountForm: 'Discount Form',
            consentForm: 'Terms & Conditions',
            distributorGroupName: 'Distributor Group Name',
            selectChioce: 'Please Select',
            KnowledgeBase: {
                name: 'Knowledge Base',
                article: 'Article',
                video: 'Video',
                RowsPerPage: 'Rows Per Page',
            },
            knowledgeBase: {
                rowsPerPage: '',
            },
        },
        ChangePassword: {
            title: 'Update Password',
            oldPwd: 'Old Password',
            newPwd: 'New Password',
            confirmNewPwd: 'Confirm New Password',
        },
        Forgot: {
            title: 'Reset your password',
            provideEmail:
                'Simply enter your email address below and we will send you an email with a link to reset your password',
            recover: 'Recover',
        },
        Register: {
            welcome: 'Welcome To TrioClear',
            pleaseRegister: 'Please complete all mandatory fields to register as a provider',
            southernCrossDentalCustomer:
                'If you are a Southern Cross Dental Customer? Enter your account number here in order to link your account',
            errorMsg: {
                firstName: 'First Name is required',
                lastName: 'Last Name is required',
                email: 'Email is required',
                password: 'Password is required',
                companyName: 'Company Name is required',
                licenseNo: 'License Number is required',
                phoneNo: 'Phone Number is required',
                clinicPhoneNo: 'Clinic Phone Number is required',
            },
            contactInfo: 'Contact Information',
            practiceDetails: 'Practice Details',
            placeholder: {
                country: 'Select your country',
                title: 'Title',
                firstName: 'First Name',
                lastName: 'Last Name',
                email: 'name@practice.com',
                phoneNo: 'Phone number',
                faxNo: 'Fax number',
                password: 'Enter password',
                confirmPassword: 'Confirm password',
                companyName: 'Enter practice or company name',
                licenseNo: 'Enter license or registration number',
                clinicPhoneNo: 'Clinic phone number',
                clinicWebsite: 'www.trioclear.com/',
                stateProvince: 'State/Province',
                localEntity: 'Local Entity',
            },
            countryRedirect: {
                au_nz: 'If you are located in Australia or New Zealand, please sign up through our local websites.',
                eu: 'For more information, you may contact our local entity:',
                footer: 'If this selection is incorrect, please choose another country above.',
            },
            dataSharingConsent: 'I agree that my personal data may be shared with the Modern Dental Europe affiliate/entity in the country selected in this form. I understand that this local entity may add my details to its customer database.',
            marketingConsent: 'I agree to receive marketing communications from Modern Dental Europe and its affiliates.',
        },
        Login: {
            welcome: 'Welcome Back',
            pleaseLogin: 'Please log in to your account',
            forgotPassword: 'Forgot password?',
            register: 'Become Our Provider',
            alertTitle: 'Special Notification',
            alertMessage:
                'Due to a high volume of TrioClear submissions lately, the loading time for some countries may be increased, we apologise for the inconvenience caused and will solve this issue soon.',
        },
        Patients: {
            new_case: 'New Case',
            trioclear_market_place: 'TrioClear Market Place',
            trioclearMarketPlace: {
                newOrder: 'New Order',
                orderHistory: 'Order History',
            },
            categories: {
                pending: 'Pending Actions',
                inProgress: 'Treatment in Progress',
                completed: 'Completed',
                archived: 'Archived',
                caseLogUnreadMessage: 'Case Log Unread Message',
                chatroomUnreadMessage: 'Chatroom Unread Message',
                unanswered: 'Unanswered',
                expired: 'Expired',
            },
            case_list: {
                title: 'Patients',
                searchPlaceHolder: 'Search or Filter',
                pendingAction: 'Pending Actions',
                treatmentInProgress: 'Treatment In Progress',
                completed: 'Completed',
                columns: {
                    notification: 'Notification',
                    caseStatus: 'Case Status',
                    profile: 'Profile',
                    gender: 'Gender',
                    patientID: 'Patient ID',
                    treatmentOption: 'Treatment Option',
                    approvalDate: 'Approval Date',
                    treatmentEndDate: 'Treatment End Date',
                    age: 'Age',
                    submissionDate: 'Submission Date',
                    remarks: 'Remarks',
                    distributor: 'Distributor',
                    group: 'Group',
                    clinic: 'Clinic',
                    drName: 'Dr. Name',
                    actions: 'Actions',
                    archived: 'Archived',
                    clientCode: 'Client Code',
                    doctorID: 'Doctor ID',
                    doctor_created_date: 'Doctor created date',
                    created_date: 'Case created date',
                    updated_date: 'Case updated date',
                    doctorId: 'Doctor ID',
                    refCode: 'Case Reference Code',
                    smile_design_case: 'Smile Design Case',
                    smile_design_type: 'Smile Design Type',
                },
                submission_date_from: 'Submission Date From',
                submission_date_to: 'Submission Date To',
                submission_start_date: 'Start Date',
                submission_end_date: 'End Date',
            },
            notification: {
                caseRow: 'Case Row',
                waitingForYourAction: 'Waiting for your action',
                treatmentInProgress: 'Treatment in progress',
                notification: 'Notification',
                statusUpdate: 'Status Update',
                unreadMsg: 'Unread Chatroom Msg',
                unreadPrivateMsg: 'Unread Private Msg',
                unreadTSandCSMsg: 'Unread TS and CS Msg',
            },
            new_trioclear_case: 'New TrioClear® Case',
            new__smile_design_case: 'New Smile Design Case',
            your_gallery: 'Your Gallery',
            options: 'Options',
            trioclearAppPhotoGallery: 'Trioclear App Photo Gallery',
            orderRetainers: 'Order Retainers',
            newIntegrativeSmileDesign: 'New Integrative Smile Design™',
            newIntegrativeSmileDesignFirstFit: 'Align & Restore Case, New Integrative Smile Design™',
            choose: 'Choose',
            trioclear_case: 'TrioClear Case',
            no_down_grade_reminder:
                'Once a specific treatment option is selected, changes to a lower treatment option cannot be accommodated. If you are unsure about the best option, we recommend selecting “Choose Treatment Option Later”. Please provide a detailed prescription to help us develop an effective treatment plan for you.',
        },
        lang: {
            NewPatient: {
                questionnaire: {
                    elastic: 'If elastics are needed which method of engagement would you like?',
                    buttonPressd: 'Button pressed on the aligner',
                    slip: 'Slip cut on the aligner',
                    cutout: 'Cutout for direct button',
                    boundings: 'Bounding to the teeth',
                },
            },
        },
        trioclear_app_notification: {
            case_log: {
                body: 'Please login to doctor submission portal if further action is needed. Case Log: {content}',
                title: 'CASE {#case_id} status has changed',
            },
            chatbox_new_messages: {
                body: 'Unread message(s) alert - CASE {#case_id}. Please login to doctor submission portal to check the new message(s) in chatbox',
                title: 'New message(s) from TrioClear !',
            },
            new_photo_upload_by_patient: {
                body: 'Track the progress of CASE {#case_id}',
                title: 'New photos are uploaded by the patient',
            },
            tracking_data_uploaded_by_patient: {
                body: 'Track the progress of CASE {#case_id}',
                title: 'Wearing time statistics record is uploaded by patient',
            },
        },
        FormDownload: {
            addFormDownload: 'Add Form Download',
            formDownload: 'Form Download',
            distributorGroupName: 'Distributor Group Name',
            displaySequenceNumber: 'Display Sequence Number',
            language: 'Language',
            formDescription: 'Form Description',
            formFile: 'Form File',
            action: 'Action',
        },
        KnowledgeBase: {
            knowledgeBase: 'Knowledge Base',
            addKnowledgeArticle: 'Add Knowledge - Article',
            addKnowledgeVideo: 'Add Knowledge - Video',
            article: 'Article',
            video: 'Video',
            distributorGroupName: 'Distributor Group Name',
            displaySequenceNumber: 'Display Sequence Number',
            language: 'Language',
            title: 'Title',
            description: 'Description',
            descriptionFile: 'Description File',
            action: 'Action',
            videoURL: 'Video URL',
        },
        SelfDesignPricing: {
            selfDesignPricing: 'Self-Design Pricing Management',
            selfDesignPricingList: 'Pricing List',
            distributorGroup: 'Distributor Group',
            currency: 'Currency',
            productCode: 'Product Code',
            product: 'Product',
            distributorCost: 'Distributor Cost',
            action: 'Action',
            editDistributorCost: 'Edit Distributor Cost',
            selectDistributorGroup: 'Select Distributor Group',
            selectCurrency: 'Select Currency',
            selectBothToView: 'Please select both Distributor Group and Currency to view pricing.',
            priceUpdated: 'Price updated successfully',
            failedToLoad: 'Failed to load pricing data',
            failedToUpdate: 'Failed to update price',
            invalidPrice: 'Please enter a valid non-negative number',
            productName: 'Product Name',
            currencyHelperText:
                'Applies to all prices under this distributor group and appears in the cost confirmation dialog',
            saveCurrency: 'Save Currency',
            currencySaved: 'Currency saved successfully',
            failedToSaveCurrency: 'Failed to save currency',
            incompletePricingError: 'Please fill in all product prices for this currency before saving',
        },
        SystemAnnouncement: {
            systemAnnouncement: 'System Announcement',
            systemName: 'System Name',
            effectiveFromDateTime: 'Effective From Date / Time',
            effectiveToDateTime: 'Effective To Date / Time',
            information: 'Information',
            save: 'Save',
            title: 'System Maintenance',
            sentence:
                'Please be informed that we will be conducting scheduled system update from 9 AM to 6 PM (UTC+8:00) on June 14 (Saturday). During this time, the TrioClear platform will be unavailable. We apologize for any inconvenience this may cause. Notification display duration:',
            from: 'from',
            to: 'to',
            dialogTitle: 'System Announcement Information',
        },
        Courier: '',
        NoticeToLoginMessage_medit_link: 'You are not logged in to MeditLink yet. Please click to log in.',
        DiffRetainer: {
            formLabel: {
                LowTrimlineAreaLabel_1: 'Low trimline area',
                LowTrimlineAreaLabel_3: 'Low trimline area',
                wireSelectLabel: 'Type of wire',
                jigPlacementLabel: 'Position the jig',
                bleachingSelect: 'Bleaching area',
            },
            formQuestionLabel: {
                archPosition: 'Which type of retainer would you like to prescribe?',
                fixedWire: 'Does the patient currently have a fixed palatal/lingual wire?',
                archAndQuantity: 'Which type of retainers would you like to prescribe?',
                occlusalBiteRampQuestion: 'Please indicate where you would like to add occlusal bite ramps if any.',
                clearRetainerDesignUpper: 'Clear Retainer Design Question -1st Set',
                clearRetainerDesignLower: 'Clear Retainer Design Question - 1st Set',
                clearRetainerDesignUpperForSecondSet: 'Clear retainer design – 2nd Set',
                clearRetainerDesignLowerForSecondSet: 'Clear retainer design – 2nd Set',
                pontic: 'If there is an anterior missing space (3-3)',
                useLatestApprovedTreatmentPlan: 'Impression',
                insertAPontic: 'Insert an esthetic pontic',
                doNotInsertAPontic: 'Do not insert a pontic',
                sectionTheWireToIgnoreTheSpace: 'Section the wire to ignore the space',
                ponticColor: 'Please choose shade color for the pontic',
                ecodontRetainerDesign: 'Retainer Design Question',
                colourPonticRequired: 'Colouring the pontic (Fee will be applied)',
                noPonticColour: 'No colour',
                pontic_v2: 'When anterior 3-3 with missing tooth/teeth, pontic will be created with options of:',
                ponticColor_v2: 'Please select the pontic shade',
                retainerDesignQuestion: 'How would you like to handle the lingual/palatal wire in the retainers?',
                impressionOption: 'Impression',
            },
            retainerDescription: {
                // "ecodontRetainers_v3": "The Ecodont Retainer system comes in a series of 3 and is made from a durable triple layer material.<br/><br/> - Triple layer material;<br/> - 1.0mm thickness;<br/> - Scalloped trimline<br/><br/> Note:<br/> Each order comes in 3",
                // "ecodontRetainersWithWire_v3": "Ecodont™ Retainer with a unique fixed wire design combined in the first of the 3 sets Ecodont™ Retainers.<br/><br/>- Easily deliver both fixed and removable retainers in 1 appointment;<br/>- Patented design allows easy removal of fixed wire holders after bonding fixed wire;<br/>- Ecodont™ Retainer: Triple layer material, 1.0mm thickness and scalloped trimline.<br/><br/>Note:<br/>Each order comes in 3<br/>(All 3 sets of Ecodont™ Retainers will have cutout for the fixed wire)",
                // "ecodontRetainer_1set_v3": "The Ecodont Retainer is now available for order in 1 set, allowing you to tailor your inventory to specific patient needs.<br/><br/>- Triple layer material;<br/>- 1.0mm thickness;<br/>- Scalloped trimline<br/><br/>Note:<br/>Each order includes 1 retainer",
                // "ecodontRetainerWithWire_1set_v3": "Ecodont™ Retainer with a unique fixed wire design combined both functionalities in a single device.<br/><br/>- Easily deliver both fixed and removable retainers in 1 appointment;<br/>- Unique design allows easy removal of fixed wire holders after bonding fixed wire.<br/>- Ecodont™ Retainer: Triple layer material, 1.0mm thickness and scalloped trimline.<br/><br/>Quantity per order: 1 piece <br/>(Note: Ecodont Retainer will have cutout for the fixed wire.)",
                bleachingRetainers_v4:
                    'The Bleaching Retainer features bleaching areas on each facial side of the anterior teeth, allowing placement of whitening agents in the bleaching area.<br/><br/> - 1.0mm thickness<br/> - Triple layered material;<br/> - Straight trimline;<br/> - Options for the bleaching area: 4-4 / 5-5 / 6-6.<br/><br/> Quantity per order:<br/> 1 piece',
                MDLSmartFitRetainers_v4:
                    'Offers high fitting accuracy with direct 3D print fabrication, eliminating the traditional model and thermoforming stages. <br/><br/>- Allows different thickness in separate zones of the retainer; <br/>- Custom occlusal features;<br/>- Space maintenance (i.e. printed full pontic);<br/>- 0.8mm thickness by default<br/><br/>Quantity per order:<br/>1 piece',
                MDLSmartFitRetainersWithWire_v4:
                    'SmartFit™ Retainer with a unique fixed wire design combined.<br/><br/>- Easily deliver both fixed and removable retainers in 1 appointment;<br/>- Patented design allows easy removal of fixed wire holders after bonding fixed wire;<br/>- Allows different thickness in separate zones of the retainer; <br/>- Custom occlusal features;<br/>- Space maintenance (i.e. printed full pontic);<br/>- 0.8mm thickness by default<br/><br/>Quantity per order:<br/>1 piece',
                fixedPalatalWire_v4:
                    'Custom bent braided stainless steel wire that fits perfectly to the lingual / palatal surfaces of the front teeth.<br/><br/>- Choice of fixed wire (Round or flat twisted);<br/>- Choice of placement jig position (middle, end or no placement jig)<br/>- Covers 3-3 by default<br/><br/>Quantity per order: <br/>1 piece',
                ecodontRetainers_v4:
                    'Ecodont® Retainers are crafted with precision in a world-class fabrication suite, ensuring optimal fit, durability and the long-term maintenance of your patients’ smiles.<br/><br/>- Triple-layered, 1.0 mm thickness.<br/>- Scalloped trimline.<br/>- BPA-free.<br/>- 3-month warranty per order.<br/>- 1 free retainer case included.<br/><br/>',
                ecodontRetainersWithWire_v4:
                    "The Ecodont® Combi Retainers is a dual-function orthodontic appliance that combines a fixed lingual retainer with the removable Ecodont® Retainers, featuring a cutout, simplifying the placement process.<br/><br/>- Deliver both fixed retainer and removable Ecodont® Retainers in 1 appointment.<br/>- <a href='https://www.youtube.com/watch?v=ZZQLOCa_b1k' target='_blank'>Placement Tutorial Video<a/><br/>- Ecodont® Retainers: Triple-layered, BPA-free material, 1.0mm thickness and scalloped trimline.<br/>- 3-month warranty for the Ecodont® Retainers per order.<br/>- 1 free retainer case included.<br/><br/>Note:<br/>This order includes 1 set of Ecodont® Retainers with a fixed retainer plus 2 sets of Ecodont® Retainers with a cutout, designed for replacement around the fixed retainer.",
                ecodontRetainer_1set_v4:
                    'Ecodont® Retainers are crafted with precision in a world-class fabrication suite, ensuring optimal fit, durability and the long-term maintenance of your patients’ smiles.<br/><br/>- Triple-layered, 1.0 mm thickness.<br/>- Scalloped trimline.<br/>- BPA-free.<br/>- 3-month warranty per order.<br/>- 1 free retainer case included.<br/>',
                ecodontRetainerWithWire_1set_v4:
                    "The Ecodont® Combi Retainers is a dual-function orthodontic appliance that combines a fixed lingual retainer with the removable Ecodont® Retainers, featuring a cutout, simplifying the placement process.<br/><br/>- Deliver both fixed retainer and removable Ecodont® Retainers in 1 appointment.<br/>- <a href='https://www.youtube.com/watch?v=ZZQLOCa_b1k' target='_blank'>Placement Tutorial Video<a/><br/>- Ecodont® Retainers: Triple-layered, BPA-free material, 1.0mm thickness and scalloped trimline.<br/>- 3-month warranty for the Ecodont® Retainers per order.<br/>- 1 free retainer case included.<br/>",
                ecodontRetainerWithVeneerShield_3set_v4:"Ecodont® Retainers are now optimized for patients with existing anterior veneers.<br/><br/><b>VeneerShield ™ featuring:</b><br/><b>- Straight line cutting with 2mm away from the gingiva over the veneered teeth -</b>Minimize unwanted forces when inserting and removing the retainers.<br/><br/><b>- Patented detective veneer contact points</b> - Ensure less force on veneer while maintaining contact for orthodontic retention.<br/><br/><b>- Increased retention in the posterior teeth</b> – Utilized by our TrioDim Force™ Technology, allowing less retention force required to be exerted on the anterior teeth with veneers.<br/><br/><b>- Removal buckle</b> – Patented design area to remove the retainer, ensuring patient won’t exerted unnecessary force on veneered teeth.<br><br><b>Ecodont® Retainers:</b><br> - Triple-layered, BPA-free material, 1.0mm thickness.<br>- 3-month warranty per order.<br>- 1 x retainer case and 1 x TrioKey included.​",
                ecodontRetainerWithVeneerShield_1set_v4:"Ecodont® Retainers are now optimized for patients with existing anterior veneers.<br/><br/><b>VeneerShield ™ featuring:</b><br/><b>- Straight line cutting with 2mm away from the gingiva over the veneered teeth -</b>Minimize unwanted forces when inserting and removing the retainers.​​<br/><br/><b>- Patented detective veneer contact points</b> - Ensure less force on veneer while maintaining contact for orthodontic retention.<br/><br/><b>- Increased retention in the posterior teeth</b> – Utilized by our TrioDim Force™ Technology, allowing less retention force required to be exerted on the anterior teeth with veneers.<br/><br/><b>- Removal buckle</b> – Patented design area to remove the retainer, ensuring patient won’t exerted unnecessary force on veneered teeth.<br><br><b>Ecodont® Retainers:</b><br> - Triple-layered, BPA-free material, 1.0mm thickness.<br>- 3-month warranty per order.<br>- 1 x retainer case and 1 x TrioKey included.",
                subTitle: {
                    ecodontRetainers: 'Recommended for immediate post-aligner treatment',
                    ecodontRetainer_1set: 'Fundamental option',
                    ecodontRetainersWithWire: 'Recommended for immediate post-aligner treatment',
                    ecodontRetainerWithWire_1set: 'Fundamental option',
                    ecodontRetainerWithVeneerShield_3set: "Recommend for immediate post-restorative treatment",
                    ecodontRetainerWithVeneerShield_1set:"Fundamental option"
                },
            },
            subOptions: {
                roundTwistWire: 'Dentaurum 3 stranded round twisted wire. 0.45 mm',
                flatTwistWire: 'Leone flat twisted wire. 0.016 x 0.022 inch',
                placementJigInMiddleOfWire: 'placement jig in middle of wire',
                placementJigOnEndsOfTheWire: 'placement jig on ends of the wire',
                noPlacementJig: 'no placement jig',
            },
            readOnlyPrescription: {
                useLastRetainerRequestImpressions: 'Use the impressions of the latest retainer order',
                lastStepOfLatestApprovedTreatmentPlan: 'Use last step of the latest approved treatment plan',
                referToDocument: "Please refer to document tab's Impressions",
                physicalImpressionByCourier: 'Physical Impression by Courier',
                waybillNumber: 'Waybill Number',
                courierCompany: 'Courier Company',
                digitalImpressionScannerPortal: 'Digital Impressions Sent by Intraoral Scanner Portal',
                scannerBrand: 'Scanner Brand',
                doctorName: 'Doctor',
                referToViewImpression: 'Please refer to view impression button to browse the uploaded files.',
                retainerType: 'Retainer Type',
                useLastRetainerRequestImpressions: 'Use the impressions of the latest retainer order',
            },
            formOptions: {
                coverLingualOrPalatalWire: 'Covering Lingual/Palatal Wire',
                NotCoverLingualOrPalatalWire: 'Do not cover Lingual/Palatal Wire',
                virtuallyRemoveLingualOrPalatalWire: 'Virtually remove lingual/palatal wire and make clear retainer',
                upperAndLower: 'Upper And Lower',
                upper: 'Upper',
                lower: 'Lower',
                biteRampNo: 'No',
                biteRampYes: 'Yes. Please specify the bite ramp position:',
                ecodontRetainers: 'Ecodont® Retainers - 3 sets',
                ecodontRetainersWithWire: 'Ecodont® Combi Retainers - 3 sets',
                ecodontRetainer_1set: 'Ecodont® Retainers - 1 set',
                ecodontRetainerWithWire_1set: 'Ecodont® Combi Retainers - 1 set',
                MDLSmartFitRetainers: 'SmartFit™ Retainer',
                MDLSmartFitRetainersWithWire: 'SmartFit™ Combi Retainer',
                ecodontRetainerWithVeneerShield_3set: 'Ecodont® Retainers with VeneerShield™ - 3 sets',
                ecodontRetainerWithVeneerShield_1set: 'Ecodont® Retainers with VeneerShield™ - 1 set',
                basicRetainers: 'Basic Retainers',
                bleachingRetainers: 'Bleaching Retainer',
                fixedPalatalWire: 'Fixed Retainer',
                useLastStep: 'Use last step of the latest approved treatment plan',
                useLastRetainerReq: 'Use the impressions of the latest retainer order',
            },
            errorMessage: {
                uploadFile: 'Please upload the files',
                displayValue:
                    'An error occurred while retrieving the display value for {{field}}. Please contact support.',
            },
        },
        AiGenerator: {
            title: 'AI Smile Generator',
            modal: {
                subtitle: 'AI-Generated Smile in Just Minutes!',
                description_generate:
                    'Generates virtual visual representations of potential smile transformations at the first appointment.',
                description_boots:
                    'Boots patient engagement and converts higher demand into sales for TrioClear treatment.',
                description_acts: 'Acts as a sales tool displayed in the clinic during patient waiting times.',
                photo_current: 'Current',
                photo_ideal: 'Ideal',
                action_title: 'Scan & unlock the AI Smile Generator!',
                action_subtitle: 'Best fit with mobile & tablet devices.',
            },
        },
        TreatmentPlanHistory: {
            designerComment: 'Designer comments',
            initialSpecial: 'Initial special instructions',
            treatmentPlanHistory: 'Treatment Plan History',
            importantNote:
                'Important: Any comments here should only relate to treatment plan requests. For all other requests,  please communicate through the “Live Support Ticket”.',
            initialSetup: 'Initial setup',
            doctorRequest: 'Doctor request',
            updatedDesignerComment: 'Updated Designer Comments',
            unsubmitted: 'Unsubmitted',
            comment: {
                inputPlaceholder: 'Input your comment',
                waitPlanUploadPlaceholder: 'Waiting for plan upload',
            },
        },
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LANG_LOAD:
            let type = typeof action.payload;
            if (type === 'string') {
                action.payload = JSON.parse(action.payload);
            } else if (type !== 'object') {
                throw new Error('Cannot identify what the lang object is');
            }
            return {
                ...state,
                isInit: true,

                dict: {
                    ...action.payload.dict,
                },
                avail: action.payload.avail,
                current: action.payload.current,
            };
        case LANG_CONFIG:
            if (Object.keys(action.payload).every((k) => ['avail', 'default'].includes(k))) {
                return {
                    ...state,
                    isInit: true,
                    ...action.payload,
                };
            }
        default:
            return state;
    }
};
